(function () {
  const money = (cents) => {
    const value = Number(cents || 0) / 100;
    return value.toLocaleString("en-US", { style: "currency", currency: "USD" });
  };
  const priceFor = (product) => {
    if (!product) return "";
    const direct = normalize(product.price);
    if (direct && !/^\$?0(?:\.00)?$/.test(direct)) return direct.startsWith("$") ? direct : `$${direct}`;
    const numericPrice = Number(product.numericPrice || 0);
    if (Number.isFinite(numericPrice) && numericPrice > 0) return numericPrice.toLocaleString("en-US", { style: "currency", currency: "USD" });
    const cents = Number(product.priceCents || 0);
    return Number.isFinite(cents) && cents > 0 ? money(cents) : "";
  };

  const normalize = (value) => String(value || "").trim();
  const lower = (value) => normalize(value).toLowerCase();
  const normalizeSlug = (value) => lower(value).replace(/&/g, "and").replace(/[\s-]+/g, "_").replace(/[^a-z0-9_]/g, "");
  const listValues = (value) => {
    if (Array.isArray(value)) {
      return Array.from(new Set(value.flatMap(listValues).filter(Boolean)));
    }
    return normalize(value)
      .split(/[,\n|]+/)
      .map((item) => item.trim())
      .filter(Boolean);
  };
  const stripHtml = (value) => normalize(value).replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
  const escapeHtml = (value) => normalize(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
  const escapeAttr = escapeHtml;
  const SNACK_SWIPE_ANALYTICS_VERSION = "v7_order_product_bridge_20260621";
  const SNACK_SWIPE_CART_ATTRIBUTE_KEYS = {
    used: "Snack Swipe Used",
    sessionId: "Snack Swipe Session ID",
    firstAddedAt: "Snack Swipe First Added At",
    lastAddedAt: "Snack Swipe Last Added At",
    sources: "Snack Swipe Add Sources",
    addActions: "Snack Swipe Add Actions",
    itemsAdded: "Snack Swipe Items Added",
    productHandles: "Snack Swipe Product Handles",
    variantIds: "Snack Swipe Variant IDs",
    savedProductHandles: "Snack Swipe Saved Product Handles",
    productSources: "Snack Swipe Product Sources",
    version: "Snack Swipe Version"
  };
  const SNACK_SWIPE_EVENT_ALIASES = {
    snack_swipe_opened: "snack_swipe_open",
    snack_swipe_loaded: false,
    snack_swipe_session_started: "snack_swipe_session_start",
    snack_swipe_product_viewed: "snack_swipe_card_view",
    snack_swipe_product_saved: "snack_swipe_decision",
    snack_swipe_product_skipped: "snack_swipe_decision",
    snack_swipe_intel_opened: "snack_swipe_snack_intel_open",
    snack_swipe_saved_item_intel_opened: "snack_swipe_snack_intel_open",
    snack_swipe_saved_list_opened: "snack_swipe_saved_list_open",
    snack_swipe_filters_opened: false,
    snack_swipe_filters_applied: "snack_swipe_filter_apply",
    snack_swipe_gesture_intro_shown: false,
    snack_swipe_gesture_intro_dismissed: false,
    snack_swipe_guide_opened: false,
    snack_swipe_guide_completed: false,
    snack_swipe_guide_skipped: false,
    snack_swipe_filter_tip_shown: false,
    snack_swipe_filter_tip_dismissed: false,
    snack_swipe_filter_value_toggled: false,
    snack_swipe_no_results: false,
    snack_swipe_deck_completed: false,
    snack_swipe_product_image_error: false,
    snack_swipe_error: false,
    snack_swipe_view_product_clicked: "snack_swipe_view_product_click",
    snack_swipe_add_to_cart_clicked: "snack_swipe_add_to_cart_click",
    snack_swipe_add_to_cart: "snack_swipe_add_to_cart_result",
    snack_swipe_saved_add_all_to_cart: "snack_swipe_add_to_cart_result",
    snack_swipe_saved_item_add_to_cart: "snack_swipe_add_to_cart_result",
    snack_swipe_product_added_to_cart: "snack_swipe_product_added_to_cart"
  };

  const filterIconPaths = {
    check: '<path d="m5 12 4.2 4.2L19 6.8"/>',
    chevron_down: '<path d="m6 9 6 6 6-6"/>',
    arrow_right: '<path d="M5 12h14"/><path d="m13 6 6 6-6 6"/>',
    reset: '<path d="M5 8a8 8 0 1 1-1.4 8"/><path d="M5 3v5h5"/>',
    criteria: '<path d="M5 7h10"/><path d="M19 7h.01"/><path d="M5 12h.01"/><path d="M9 12h10"/><path d="M5 17h7"/><path d="M16 17h3"/>',
    snack_count: '<path d="M4 8.5 12 4l8 4.5v9L12 22l-8-4.5Z"/><path d="m4 8.5 8 4.5 8-4.5"/><path d="M12 13v9"/>',
    filters: '<path d="M4 7h9"/><path d="M17 7h3"/><circle cx="15" cy="7" r="2"/><path d="M4 12h3"/><path d="M11 12h9"/><circle cx="9" cy="12" r="2"/><path d="M4 17h12"/><path d="M20 17h.01"/><circle cx="18" cy="17" r="2"/>',
    section_missions: '<circle cx="12" cy="12" r="3.5"/><path d="M12 2.8v3"/><path d="M12 18.2v3"/><path d="M2.8 12h3"/><path d="M18.2 12h3"/><path d="m5.5 5.5 2.1 2.1"/><path d="m16.4 16.4 2.1 2.1"/><path d="m18.5 5.5-2.1 2.1"/><path d="m7.6 16.4-2.1 2.1"/>',
    section_snack_types: '<path d="M5 8.5 12 4l7 4.5v7L12 20l-7-4.5Z"/><path d="m5 8.5 7 4.5 7-4.5"/><path d="M12 13v7"/>',
    section_flavors: '<path d="M16.8 7.2c-1.5-1.6-4.2-1.8-6-.4-2 1.5-2.2 4.2-.6 5.6 1.4 1.2 3.7 1 5-.2 1.6-1.5 1.4-3.8-.1-4.7-2-1.2-5.3.1-6.7 2.9-1.6 3.3.5 7.2 4.3 7.6 2.7.3 5.6-1.1 7-3.5"/><path d="M5 17.5c1.1 1.6 3 2.8 5.1 3"/><path d="M19 5.4c-1-.9-2.2-1.5-3.6-1.8"/>',
    section_countries: '<circle cx="12" cy="12" r="8"/><path d="M4 12h16"/><path d="M12 4c2.4 2.4 3.6 5.1 3.6 8s-1.2 5.6-3.6 8"/><path d="M12 4c-2.4 2.4-3.6 5.1-3.6 8s1.2 5.6 3.6 8"/>',
    staff_picks: '<path d="m12 3.4 2.4 4.9 5.4.8-3.9 3.8.9 5.4-4.8-2.6-4.8 2.6.9-5.4-3.9-3.8 5.4-.8Z"/>',
    under_5: '<path d="M4 12.3 12.3 4H20v7.7L11.7 20Z"/><path d="M16 8h.01"/><path d="M12 8v8"/><path d="M14.3 9.4c-.6-.7-2.7-.9-3.3.1-.8 1.5 3.5 1.4 3 3.5-.3 1.4-2.8 1.4-4 .2"/>',
    sale: '<path d="M5 19 19 5"/><circle cx="7.5" cy="7.5" r="2"/><circle cx="16.5" cy="16.5" r="2"/>',
    new: '<path d="M12 3.5 14.1 9l5.4 2.1-5.4 2.1L12 18.5l-2.1-5.3-5.4-2.1L9.9 9Z"/>',
    best_sellers: '<path d="M8 21h8"/><path d="M12 17v4"/><path d="M7 4h10v4.5a5 5 0 0 1-10 0Z"/><path d="M7 6H4.5a2.5 2.5 0 0 0 0 5H8"/><path d="M17 6h2.5a2.5 2.5 0 0 1 0 5H16"/><path d="M9.5 21h5"/>',
    last_chance: '<path d="M7 3h10"/><path d="M7 21h10"/><path d="M8 3c0 4.5 2.7 6.1 4 7 1.3-.9 4-2.5 4-7"/><path d="M16 21c0-4.5-2.7-6.1-4-7-1.3.9-4 2.5-4 7"/><path d="M9 8h6"/><path d="M9.5 17h5"/>',
    international: '<circle cx="12" cy="12" r="8"/><path d="M4 12h16"/><path d="M12 4c2.4 2.4 3.6 5.1 3.6 8s-1.2 5.6-3.6 8"/><path d="M12 4c-2.4 2.4-3.6 5.1-3.6 8s1.2 5.6 3.6 8"/>',
    candy: '<path d="m9 9 6 6"/><path d="m15 9-6 6"/><path d="M8 8 3.5 5.5 5.5 10"/><path d="m16 16 4.5 2.5-2-4.5"/><rect x="7.5" y="7.5" width="9" height="9" rx="2" transform="rotate(45 12 12)"/>',
    chips: '<path d="M7.5 8.5c1.9-2.4 5-3.1 7.8-1.8 1.5.7 2.9 1.9 4.2 3.5-2.1 1.1-4.4 1.4-6.7.9-2.2-.5-4-1.4-5.3-2.6Z"/><path d="M5.2 13c2-1.9 4.8-2.4 7.4-1.2 1.5.7 2.8 1.8 3.9 3.3-2 .9-4.2 1.1-6.2.6-2.1-.5-3.8-1.4-5.1-2.7Z"/><path d="M4.2 17.4c1.8-1.4 4.2-1.6 6.3-.6 1.1.5 2.1 1.3 3 2.4-1.7.6-3.5.7-5.2.3-1.7-.4-3-1.1-4.1-2.1Z"/>',
    chocolate: '<rect x="5" y="5" width="14" height="14" rx="2"/><path d="M5 10h14"/><path d="M5 14h14"/><path d="M10 5v14"/><path d="M14 5v14"/>',
    cookies: '<circle cx="12" cy="12" r="8"/><circle cx="9" cy="9" r=".8"/><circle cx="14.5" cy="8.5" r=".8"/><circle cx="14" cy="14.5" r=".8"/><circle cx="8.5" cy="15" r=".8"/>',
    drinks: '<path d="M7 5h10l-1.5 16h-7Z"/><path d="M9 5l1-3h6"/><path d="M8 10h8"/><path d="M9 15h6"/>',
    freeze_dried: '<path d="M12 3v18"/><path d="M4.2 7.5 19.8 16.5"/><path d="M19.8 7.5 4.2 16.5"/><path d="m8 5 4 4 4-4"/><path d="m8 19 4-4 4 4"/>',
    gummies: '<path d="M8.5 8.2a2 2 0 1 1 3-2.5 2.1 2.1 0 0 1 4 1 2 2 0 1 1 2.4 2.9c1.3 1 2.1 2.6 2.1 4.4 0 3.3-2.7 6-8 6s-8-2.7-8-6c0-1.8.8-3.4 2.1-4.4a2 2 0 0 1 2.4-1.4Z"/><path d="M9 13h.01"/><path d="M15 13h.01"/><path d="M10 16c1.2.8 2.8.8 4 0"/>',
    merch: '<path d="M8 5 5 7.5 7 11l2-1v11h8V10l2 1 2-3.5L18 5l-3 2h-4Z"/>',
    other: '<path d="M4.5 9 12 5l7.5 4-7.5 4Z"/><path d="M4.5 9v7l7.5 4 7.5-4V9"/><path d="M12 13v7"/><path d="M10.4 9.8c.2-1.1 1-1.8 2.1-1.8 1.2 0 2.1.8 2.1 1.9 0 1.5-1.8 1.7-2.2 2.8"/><path d="M12.4 15.3h.01"/>',
    sweet: '<circle cx="11" cy="9" r="5"/><path d="M9 9c0-1.2 1-2.2 2.2-2.2 1.7 0 2.7 2 1.5 3.2-.9.9-2.7.7-3.5-.4-.9-1.4.2-3.4 2.4-3.8"/><path d="m14.5 12.5 4.5 4.5"/><path d="m16.5 15 2.8-.3"/><path d="m16.8 17.3-.3-2.8"/>',
    sour: '<path d="M5.2 15.8c1.5-5.1 5.6-9 11.6-11.1 1.8 5.7-1 11.5-6.6 13.3-1.9.6-3.6-.1-5-2.2Z"/><path d="m7.8 15.4 8.9-8.9"/><path d="M11.4 10.8c1.4 1.2 2.8 1.8 4.6 1.8"/><path d="M9.4 13.1c1 1 2.2 1.5 3.6 1.6"/>',
    spicy: '<path d="M14.2 4.2c.9 2.8-.4 4.6-2.8 5.8-3.1 1.6-4.7 4.2-3.5 6.8 1.4 3 5.7 3.8 8.8 1.1 2.9-2.6 1.6-6.6-1.4-8.1-1.8-.9-2-2.6-1.1-5.6Z"/><path d="M15.7 4.6c1.5.1 2.8.8 3.8 2"/><path d="M10.5 15.5c1.4 1 3.4 1 5-.2"/>',
    salty: '<path d="M9 4h6l1 16H8Z"/><path d="M9 8h6"/><path d="M10 12h.01"/><path d="M14 12h.01"/><path d="M12 16h.01"/>',
    savory: '<path d="M5 12.5h14"/><path d="M7 12.5v1.2a5 5 0 0 0 10 0v-1.2"/><path d="M8 18h8"/><path d="M8 8c0-1.2 1-1.4 1-2.6"/><path d="M12 8c0-1.2 1-1.4 1-2.6"/><path d="M16 8c0-1.2 1-1.4 1-2.6"/>'
  };

  const filterIconSvg = (name, className = "gs-swipe-filter__svg") => {
    const key = normalizeSlug(name || "other");
    const paths = filterIconPaths[key] || filterIconPaths.other;
    return `<svg class="${escapeAttr(className)}" viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${paths}</svg>`;
  };

  const tagValue = (product, prefixes) => {
    const tags = Array.isArray(product.tags) ? product.tags : [];
    for (const tag of tags) {
      const tagText = normalize(tag);
      for (const prefix of prefixes) {
        const prefixText = `${prefix}:`;
        if (lower(tagText).startsWith(prefixText)) {
          return tagText.slice(prefixText.length).trim();
        }
      }
    }
    return "";
  };

  const flavorProfileTags = (product) => {
    const source = [];
    if (Array.isArray(product.tags)) source.push(...product.tags);
    if (Array.isArray(product.vibes)) source.push(...product.vibes);
    if (typeof product.vibes === "string") source.push(...product.vibes.split(","));
    source.push(...listValues(product.flavorProfiles));

    const preferred = ["sweet", "spicy", "sour", "salty", "savory"];
    const matched = preferred.filter((flavorProfile) => source.some((tag) => lower(tag).includes(flavorProfile)));
    const prefixed = source
      .map((tag) => normalize(tag))
      .filter((tag) => lower(tag).startsWith("vibe:"))
      .map((tag) => tag.slice(5).trim())
      .filter(Boolean);

    return Array.from(new Set([...prefixed, ...matched])).slice(0, 4);
  };

  const countryFor = (product) => {
    return normalize(product.originLabel)
      || normalize(product.country)
      || normalize(product.originCountry).replace(/_/g, " ")
      || tagValue(product, ["country", "origin", "from"]);
  };

  const classFor = (product) => {
    return normalize(product.snackClass)
      || normalize(product.snackType)
      || listValues(product.snackTypes)[0]
      || tagValue(product, ["class", "snack class", "category"])
      || normalize(product.productType)
      || "Snack Drop";
  };

  const productText = (product) => {
    const tags = Array.isArray(product.tags) ? product.tags.join(" ") : "";
    const explicitFields = [
      product.originCountry,
      product.originLabel,
      product.snackType,
      ...listValues(product.snackTypes),
      ...listValues(product.flavorProfiles),
      ...listValues(product.missions),
      ...listValues(product.cardBadges)
    ].join(" ");
    return lower(`${product.title || ""} ${product.handle || ""} ${tags} ${explicitFields}`);
  };

  const CARD_BADGE_DEFINITIONS = {
    staff_picks: {
      label: "Staff Pick",
      eyebrow: "",
      tone: "staff_picks",
      priority: 100
    },
    sale: {
      label: "On Sale",
      eyebrow: "",
      tone: "sale",
      priority: 90
    },
    last_chance: {
      label: "Last Chance",
      eyebrow: "",
      tone: "last_chance",
      priority: 80
    },
    best_sellers: {
      label: "Best Seller",
      eyebrow: "",
      tone: "best_sellers",
      priority: 70
    },
    new: {
      label: "New",
      eyebrow: "",
      tone: "new",
      priority: 60
    },
    under_5: {
      label: "Under $5",
      eyebrow: "",
      tone: "under_5",
      priority: 50
    },
    international: {
      label: "Imported",
      eyebrow: "",
      tone: "international",
      priority: 40
    }
  };

  const merchBadgesFor = (product) => {
    const compareAt = Number(product.compareAtPriceCents || 0);
    const price = Number(product.priceCents || 0);
    const explicitPrimary = normalizeSlug(
      product.primaryBadge ||
      product.snackSwipePrimaryBadge ||
      product.snack_swipe_primary_badge ||
      product?.metafields?.snack_swipe?.primary_badge?.value ||
      product?.metafields?.snack_swipe?.primary_badge ||
      product?.metafields?.["snack_swipe.primary_badge"]?.value ||
      product?.metafields?.["snack_swipe.primary_badge"] ||
      ""
    );
    const explicitBadges = listValues(product.cardBadges).map(normalizeSlug);
    const explicitMissions = listValues(product.missions).map(normalizeSlug);
    const badges = [];
    const addBadge = (slug) => {
      const key = normalizeSlug(slug);
      const definition = CARD_BADGE_DEFINITIONS[key];
      if (!definition || badges.some((badge) => badge.slug === key)) return;
      badges.push({ slug: key, ...definition, icon: definition.eyebrow });
    };

    if (explicitPrimary) addBadge(explicitPrimary);
    explicitBadges.forEach(addBadge);

    if (!explicitPrimary && !explicitBadges.length) {
      explicitMissions.forEach(addBadge);
    }
    if (product.onSale === true || explicitBadges.includes("sale") || explicitPrimary === "sale" || (compareAt && price && compareAt > price)) {
      addBadge("sale");
    }
    if (price && price <= 500) {
      addBadge("under_5");
    }

    return badges
      .sort((a, b) => b.priority - a.priority)
      .slice(0, 1);
  };

  const missionBadgesFor = (product) => {
    const compareAt = Number(product.compareAtPriceCents || 0);
    const price = Number(product.priceCents || 0);
    const missionMeta = [
      product?.metafields?.snack_swipe?.missions,
      product?.metafields?.snack_swipe?.missions?.value,
      product?.metafields?.["snack_swipe.missions"],
      product?.metafields?.["snack_swipe.missions"]?.value,
      product?.metafields?.missions,
      product?.metafields?.missions?.value
    ];
    const canonicalMission = (value) => {
      const key = normalizeSlug(value);
      const aliases = {
        staff: "staff_picks",
        staff_pick: "staff_picks",
        staff_picks: "staff_picks",
        best: "best_sellers",
        best_seller: "best_sellers",
        best_sellers: "best_sellers",
        bestseller: "best_sellers",
        bestsellers: "best_sellers",
        new_arrival: "new",
        new_arrivals: "new",
        on_sale: "sale",
        sale: "sale",
        under5: "under_5",
        under_5: "under_5",
        under_5_dollars: "under_5",
        last_chance: "last_chance",
        international: "international",
        import: "international",
        imported: "international"
      };
      return aliases[key] || key;
    };
    const explicitMissions = Array.from(new Set([
      ...metaListValues(product.missions),
      ...metaListValues(product.snackSwipeMissions),
      ...metaListValues(product.snack_swipe_missions),
      ...missionMeta.flatMap(metaListValues)
    ].map(canonicalMission).filter(Boolean)));
    const definitions = {
      staff_picks: { key: "staff_picks", label: "Staff Picks", icon: "★", iconName: "staff_picks", tone: "staff_picks", priority: 70 },
      sale: { key: "sale", label: "On Sale", icon: "%", iconName: "sale", tone: "sale", priority: 60 },
      last_chance: { key: "last_chance", label: "Last Chance", icon: "LAST", iconName: "last_chance", tone: "last_chance", priority: 50 },
      best_sellers: { key: "best_sellers", label: "Best Sellers", icon: "★", iconName: "best_sellers", tone: "best_sellers", priority: 40 },
      new: { key: "new", label: "New Arrivals", icon: "NEW", iconName: "new", tone: "new", priority: 30 },
      under_5: { key: "under_5", label: "Under $5", icon: "$", iconName: "under_5", tone: "under_5", priority: 20 },
      international: { key: "international", label: "International", icon: "INTL", iconName: "international", tone: "international", priority: 10 }
    };
    const missions = [];
    const pushMission = (key) => {
      const mission = definitions[key];
      if (mission && !missions.some((item) => item.key === mission.key)) missions.push(mission);
    };

    explicitMissions.forEach(pushMission);
    if (isUnderFive(product)) pushMission("under_5");
    if (product.onSale === true || explicitMissions.includes("sale") || (compareAt && price && compareAt > price)) pushMission("sale");

    return missions.sort((a, b) => b.priority - a.priority);
  };

  const missionTrophyBadgesFor = (product) => {
    const badges = missionBadgesFor(product);
    if (badges.length === 3) return badges.slice(0, 2);
    if (badges.length > 4) return badges.slice(0, 4);
    return badges;
  };

  const iconFor = (tag) => {
    const text = lower(tag);
    if (text.includes("spicy")) return "🌶️";
    if (text.includes("sweet")) return "🍬";
    if (text.includes("sour")) return "🍋";
    if (text.includes("salty")) return "🥨";
    if (text.includes("crunch")) return "💥";
    return "🛸";
  };

  const countryFlag = (country) => {
    const text = lower(country);
    if (text.includes("japan")) return "🇯🇵";
    if (text.includes("uk") || text.includes("united kingdom") || text.includes("britain")) return "🇬🇧";
    if (text.includes("canada")) return "🇨🇦";
    if (text.includes("india")) return "🇮🇳";
    if (text.includes("mexico")) return "🇲🇽";
    if (text.includes("korea")) return "🇰🇷";
    if (text.includes("taiwan")) return "🇹🇼";
    if (text.includes("malaysia")) return "🇲🇾";
    if (text.includes("thailand")) return "🇹🇭";
    if (text.includes("china")) return "🇨🇳";
    if (text.includes("australia")) return "🇦🇺";
    if (text.includes("brazil")) return "🇧🇷";
    if (text.includes("uae") || text.includes("dubai") || text.includes("united arab emirates")) return "🇦🇪";
    if (text.includes("usa") || text.includes("united states")) return "🇺🇸";
    return "🌐";
  };

  const countryDisplayName = (country) => {
    const text = lower(country);
    if (text === "uk" || text.includes("united kingdom") || text.includes("britain")) return "United Kingdom";
    if (text === "usa" || text.includes("united states")) return "USA";
    if (text === "uae" || text.includes("united arab emirates") || text.includes("dubai")) return "UAE";
    return normalize(country);
  };

  const cleanLabel = (value) => normalize(value).replace(/^vibe:\s*/i, "");
  const placeholderMetaValues = new Set(["", "other", "unknown", "n/a", "na", "none", "add data", "snack drop"]);
  const isUsefulMetaValue = (value) => !placeholderMetaValues.has(lower(value).replace(/[_-]+/g, " "));

  const sizeFor = (product) => {
    const text = `${product.title || ""} ${product.description || ""} ${(product.tags || []).join(" ")}`;
    const match = text.match(/\b(\d+(?:\.\d+)?)\s?(ml|l|g|kg|oz|ct|pack|pcs?)\b/i);
    return match ? `${match[1]} ${match[2]}`.replace(/\bml\b/i, "mL") : "";
  };

  const smartTruncate = (value, limit) => {
    const text = normalize(value);
    if (text.length <= limit) return text;
    const clipped = text.slice(0, limit - 3);
    const lastSpace = clipped.lastIndexOf(" ");
    return `${clipped.slice(0, lastSpace > 24 ? lastSpace : clipped.length).trim()}...`;
  };

  const displayLength = (value) => Array.from(normalize(value)).length;

  const titleClassFor = (value, breakpoints) => {
    const length = displayLength(value);
    if (length <= breakpoints.standard) return { className: "is-title-standard", length };
    if (length <= breakpoints.compact) return { className: "is-title-compact", length };
    if (length <= breakpoints.tight) return { className: "is-title-tight", length };
    return { className: "is-title-emergency", length };
  };

  const swipeTitleClassFor = (value) => titleClassFor(value, {
    standard: 24,
    compact: 30,
    tight: 34
  });

  const intelTitleClassFor = (value) => {
    const length = displayLength(value);
    if (length <= 28) return { className: "is-title-standard", length };
    if (length <= 42) return { className: "is-title-medium", length };
    if (length <= 56) return { className: "is-title-compact", length };
    return { className: "is-title-emergency", length };
  };

  const titleBucketClasses = [
    "is-long-title",
    "is-extra-long-title",
    "is-title-standard",
    "is-title-medium",
    "is-title-compact",
    "is-title-tight",
    "is-title-emergency"
  ];

  const applyTitleBucket = (element, bucket) => {
    if (!element || !bucket) return;
    element.classList.remove(...titleBucketClasses);
    element.classList.add(bucket.className);
    element.dataset.gsTitleLength = String(bucket.length);
  };

  const flagPresentationIssue = (message, payload = {}) => {
    const params = new URL(window.location.href).searchParams;
    if (params.get("swipe_debug") === "1") {
      console.warn(`[Snack Swipe App] presentation:${message}`, payload);
    }
  };

  const escapeRegExp = (value) => normalize(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const cleanDisplayTitle = (title, product = {}) => {
    let result = normalize(title);
    const countryValues = listValues([countryFor(product), product.originCountry, product.originLabel])
      .map((value) => normalize(value).replace(/_/g, " "))
      .filter(Boolean);
    countryValues.forEach((country) => {
      result = result.replace(new RegExp(`\\b${escapeRegExp(country)}\\b`, "gi"), "");
    });
    result = result
      .replace(/\s*\((?:uk|united kingdom|canada|mexico|taiwan|china|brazil|india|australia|japan|korea|south korea|malaysia|usa|united states|united arab emirates|uae)\)\s*/gi, " ")
      .replace(/\b\d+(?:\.\d+)?\s?(?:fl\s?oz|ml|kg|g|oz|ct|count|pack|pcs?|l)\b/gi, "")
      .replace(/\b(?:limited edition|new arrival|imported|import)\b/gi, "")
      .replace(/\s*[-|/]\s*(?:$|[-|/])/g, " ")
      .replace(/\s{2,}/g, " ")
      .replace(/^[\s\-|/]+|[\s\-|/]+$/g, "");
    return result;
  };

  const rawDisplayTitleFor = (product) => {
    return normalize(
      product?.displayTitle
      || product?.swipeTitle
      || product?.shortTitle
      || product?.metafields?.snack_swipe?.display_title?.value
      || product?.metafields?.snack_swipe?.display_title
      || product?.metafields?.snack_swipe?.short_title?.value
      || product?.metafields?.snack_swipe?.short_title
      || product?.metafields?.snack_swipe?.swipe_title?.value
      || product?.metafields?.snack_swipe?.swipe_title
    ) || tagValue(product, ["display title", "swipe title", "short title"]);
  };

  const rawIntelTitleFor = (product) => {
    return normalize(
      product?.snackIntelTitle
      || product?.intelTitle
      || product?.snack_swipe_intel_title
      || product?.metafields?.snack_swipe?.intel_title?.value
      || product?.metafields?.snack_swipe?.intel_title
      || product?.metafields?.["snack_swipe.intel_title"]?.value
      || product?.metafields?.["snack_swipe.intel_title"]
    ) || rawDisplayTitleFor(product);
  };

  const snackIntelTitleFor = (product) => {
    const override = rawIntelTitleFor(product);
    const title = cleanDisplayTitle(override || product?.title, product);

    return title || product?.title || "Snack details";
  };

  const displayTitleFor = (product) => {
    const override = rawDisplayTitleFor(product);
    const title = cleanDisplayTitle(override || product?.title, product);

    return title || product?.title || "Snack Drop";
  };

  const numberFrom = (...values) => {
    for (const value of values) {
      if (value === null || value === undefined || value === "") continue;
      if (typeof value === "number" && Number.isFinite(value)) return value;
      if (typeof value === "string") {
        const match = value.replace(/,/g, "").match(/\d+(?:\.\d+)?/);
        if (match) return Number(match[0]);
      }
      if (typeof value === "object") {
        const nested = numberFrom(value.value, value.amount, value.rating, value.count);
        if (nested) return nested;
      }
    }
    return 0;
  };

  const objectFrom = (value) => {
    if (!value) return {};
    if (typeof value === "object") return value;
    if (typeof value === "string") {
      try {
        return JSON.parse(value);
      } catch (_error) {
        return {};
      }
    }
    return {};
  };

  const metaRawValue = (value) => {
    if (value && typeof value === "object" && Object.prototype.hasOwnProperty.call(value, "value")) {
      return value.value;
    }
    return value;
  };

  const metaParsedValue = (value) => {
    const raw = metaRawValue(value);
    if (typeof raw === "string") {
      const trimmed = raw.trim();
      if ((trimmed.startsWith("{") && trimmed.endsWith("}")) || (trimmed.startsWith("[") && trimmed.endsWith("]"))) {
        try {
          return JSON.parse(trimmed);
        } catch (_error) {
          return raw;
        }
      }
    }
    return raw;
  };

  const metaListValues = (value) => {
    const parsed = metaParsedValue(value);
    if (Array.isArray(parsed)) return parsed.map(normalize).filter(Boolean);
    if (parsed && typeof parsed === "object") {
      if (Array.isArray(parsed.values)) return parsed.values.map(normalize).filter(Boolean);
      if (Array.isArray(parsed.value)) return parsed.value.map(normalize).filter(Boolean);
      if (Array.isArray(parsed.list)) return parsed.list.map(normalize).filter(Boolean);
    }
    return listValues(parsed);
  };

  const reviewFor = (product) => {
    const metafields = product.metafields || {};
    const reviewsMeta = objectFrom(metaParsedValue(metafields.reviews));
    const reviewsRatingMeta = metaParsedValue(
      product.reviewsRating
      || product.reviews_rating
      || metafields?.reviews?.rating
      || metafields?.reviews?.rating?.value
      || reviewsMeta.rating
      || metafields["reviews.rating"]
      || metafields["reviews.rating"]?.value
    );
    const reviewsRatingValue = metaParsedValue(reviewsRatingMeta);
    const reviewsCountMeta = metaParsedValue(
      product.reviewsRatingCount
      || product.reviews_rating_count
      || metafields?.reviews?.rating_count
      || metafields?.reviews?.rating_count?.value
      || reviewsMeta.rating_count
      || reviewsMeta.ratingCount
      || metafields["reviews.rating_count"]
      || metafields["reviews.rating_count"]?.value
    );
    const reviewsCountValue = metaParsedValue(reviewsCountMeta);
    const judgeMe = objectFrom(metaParsedValue(product.judgeMe || product.judgeme || product.judge_me || metafields.judgeMe || metafields.judgeme || metafields.judge_me));
    const judgeMeWidgetRaw = product.reviewWidgetData
      || product.judgeMeReviewWidgetData
      || product.judgemeReviewWidgetData
      || metafields?.judgeme?.review_widget_data?.value
      || metafields?.judgeme?.review_widget_data
      || metafields?.judgeMe?.review_widget_data?.value
      || metafields?.judgeMe?.review_widget_data
      || metafields["judgeme.review_widget_data"]?.value
      || metafields["judgeme.review_widget_data"]
      || judgeMe.review_widget_data?.value
      || judgeMe.review_widget_data;
    const judgeMeWidget = objectFrom(metaParsedValue(judgeMeWidgetRaw));
    const rating = numberFrom(
      product.reviewRating,
      product.rating,
      product.averageRating,
      product.average_rating,
      product.ratingAverage,
      product.judgeMeRating,
      product.judgemeRating,
      product.judgeMeAverageRating,
      product.judgemeAverageRating,
      product.judgeme_average_rating,
      reviewsRatingValue?.rating,
      reviewsRatingValue?.value,
      reviewsRatingMeta?.rating,
      reviewsRatingMeta?.value,
      reviewsRatingMeta,
      judgeMe.average_rating,
      judgeMe.averageRating,
      judgeMe.rating,
      judgeMeWidget.average_rating,
      judgeMeWidget.averageRating,
      judgeMeWidget.rating
    );
    const count = numberFrom(
      product.reviewCount,
      product.reviewsCount,
      product.ratingCount,
      product.review_count,
      product.numberOfReviews,
      product.number_of_reviews,
      product.judgeMeReviewCount,
      product.judgemeReviewCount,
      product.judgemeNumberOfReviews,
      product.judgeme_number_of_reviews,
      reviewsCountValue?.count,
      reviewsCountValue?.value,
      reviewsCountValue,
      reviewsCountMeta?.count,
      reviewsCountMeta?.value,
      reviewsCountMeta,
      judgeMe.number_of_reviews,
      judgeMe.numberOfReviews,
      judgeMe.review_count,
      judgeMe.reviewCount,
      judgeMe.count,
      judgeMeWidget.number_of_reviews,
      judgeMeWidget.numberOfReviews,
      judgeMeWidget.review_count,
      judgeMeWidget.reviewCount,
      judgeMeWidget.count
    );
    if (!rating || !count || rating < 4) return null;
    return {
      rating: Math.max(0, Math.min(5, rating)),
      count
    };
  };

  const availabilityFor = (product) => {
    const text = productText(product);
    if (!productHasPurchasableVariant(product)) return { label: "Sold Out", status: "sold-out" };
    if (!productHasValidPrice(product)) return { label: "Unavailable", status: "unavailable" };
    if (text.includes("coming soon") || text.includes("coming-soon")) return { label: "Coming Soon", status: "coming-soon" };
    return { label: "In Stock", status: "in-stock" };
  };

  const shortDescriptionFor = (product) => {
    const displayTitle = lower(displayTitleFor(product));
    const rawTitle = lower(product.title || product.fullTitle || "");
    const candidateSources = [
      product?.metafields?.snack_swipe?.short_summary?.value ||
      product?.metafields?.snack_swipe?.short_summary ||
      product.shortSummary ||
      product.short_summary ||
      product?.metafields?.custom?.short_description?.value ||
      product?.metafields?.short_description?.value ||
      product.shortDescription ||
      product.short_description ||
      product.seoDescription ||
      product.metaDescription ||
      ""
    ];

    for (const candidate of candidateSources) {
      const cleaned = stripHtml(candidate);
      const normalized = lower(cleaned);
      if (!cleaned) continue;
      if (normalized === rawTitle || normalized === displayTitle) continue;
      return cleaned;
    }

    const fallback = fullDescriptionFor(product);
    return fallback ? smartTruncate(fallback, 220) : "";
  };

  const fullDescriptionFor = (product) => {
    return stripHtml(product.fullDescription || product.descriptionFull || product.descriptionHtml || product.description || "");
  };

  const productImageFor = (product) => {
    if (!product) return "";
    return normalize(product.cutoutImage) || normalize(product.image) || normalize(product.shopifyImage);
  };

  const detailIconForClass = (value) => {
    const text = lower(value);
    if (text.includes("drink") || text.includes("soda") || text.includes("beverage")) return "🥤";
    if (text.includes("cookie")) return "🍪";
    if (text.includes("candy") || text.includes("gummy")) return "🍬";
    if (text.includes("chip") || text.includes("pretzel")) return "🥨";
    if (text.includes("bundle")) return "🎁";
    if (text.includes("swag") || text.includes("shirt")) return "👕";
    if (text.includes("chocolate")) return "🍫";
    return "✦";
  };

  const detailSvgIcon = (name) => {
    const icons = {
      globe: '<svg viewBox="0 0 48 48" focusable="false"><circle cx="24" cy="24" r="18"/><path d="M6 24h36M24 6c6 6 9 12 9 18s-3 12-9 18M24 6c-6 6-9 12-9 18s3 12 9 18"/></svg>',
      drink: '<svg viewBox="0 0 48 48" focusable="false"><path d="M15 12h18l-3 28H18L15 12Z"/><path d="M19 12l2-6h12"/><path d="M17 22h14"/></svg>',
      snack: '<svg viewBox="0 0 48 48" focusable="false"><path d="M12 15c5-5 19-5 24 0v20c-5 5-19 5-24 0V15Z"/><path d="M16 20c5 3 11 3 16 0M16 29c5 3 11 3 16 0"/></svg>',
      candy: '<svg viewBox="0 0 48 48" focusable="false"><path d="M18 18h12v12H18z" transform="rotate(45 24 24)"/><path d="M13 18l-7-4 4 7M35 30l7 4-4-7M18 35l-4 7 7-4M30 13l4-7-7 4"/></svg>',
      bundle: '<svg viewBox="0 0 48 48" focusable="false"><path d="M11 19h26v22H11z"/><path d="M8 13h32v8H8zM24 13v28"/><path d="M24 13c-7-10-17-2-8 3M24 13c7-10 17-2 8 3"/></svg>',
      star: '<svg viewBox="0 0 48 48" focusable="false"><path d="m24 6 5.5 11.2 12.4 1.8-9 8.8 2.1 12.4L24 34.3 12.9 40.2 15 27.8 6 19l12.5-1.8L24 6Z"/></svg>'
    };
    return icons[name] || icons.snack;
  };

  const detailSvgIconForClass = (value) => {
    const text = lower(value);
    if (text.includes("drink") || text.includes("soda") || text.includes("beverage")) return detailSvgIcon("drink");
    if (text.includes("bundle")) return detailSvgIcon("bundle");
    if (text.includes("candy") || text.includes("gummy") || text.includes("chocolate")) return detailSvgIcon("candy");
    return detailSvgIcon("snack");
  };

  const splitCombinedMetaValues = (value) => {
    return metaListValues(value)
      .flatMap((item) => normalize(item).split(/\s*(?:&|\+|\/|\band\b)\s*/i))
      .map(cleanLabel)
      .filter(isUsefulMetaValue);
  };

  const canonicalSnackTypeFor = (value) => {
    const text = lower(cleanLabel(value)).replace(/[_-]+/g, " ");
    const slug = normalizeSlug(text);
    const aliases = {
      beverages: "Drinks",
      beverage: "Drinks",
      drink: "Drinks",
      drinks: "Drinks",
      soda: "Drinks",
      sodas: "Drinks",
      chocolate: "Chocolate",
      chocolates: "Chocolate",
      candy: "Candy",
      candies: "Candy",
      gummies: "Gummies",
      gummy: "Gummies",
      chips: "Chips",
      chip: "Chips",
      crisps: "Chips",
      crisp: "Chips",
      pretzels: "Chips",
      pretzel: "Chips",
      popcorn: "Other",
      nuts: "Other",
      nut: "Other",
      pastries: "Other",
      pastry: "Other",
      cakes: "Other",
      cake: "Other",
      freeze_dried: "Freeze Dried",
      freeze_dried_candy: "Freeze Dried",
      merch: "Merch",
      merchandise: "Merch",
      swag: "Merch",
      cookies: "Cookies",
      cookie: "Cookies",
      biscuits: "Cookies",
      biscuit: "Cookies",
      noodles: "Other",
      ramen: "Other",
      cereal: "Other",
      cereals: "Other",
      sauce: "Other",
      sauces: "Other",
      spread: "Other",
      spreads: "Other",
      snack: "Other",
      snacks: "Other",
      bundle: "Other",
      bundles: "Other",
      other: "Other"
    };
    return aliases[slug] || "";
  };

  const canonicalFlavorFor = (value) => {
    const text = lower(cleanLabel(value)).replace(/[_-]+/g, " ");
    const slug = normalizeSlug(text);
    const aliases = {
      sweet: "Sweet",
      sour: "Sour",
      spicy: "Spicy",
      hot: "Spicy",
      salty: "Salty",
      savory: "Savory",
      savoury: "Savory"
    };
    return aliases[slug] || "";
  };

  const uniqueCanonicalValues = (values, canonicalizer) => {
    const seen = new Set();
    const result = [];
    values.forEach((value) => {
      const canonical = canonicalizer(value);
      const key = normalizeSlug(canonical);
      if (!key || seen.has(key)) return;
      seen.add(key);
      result.push(canonical);
    });
    return result;
  };

  const fallbackSnackTypeMetaValues = (value) => {
    const slug = normalizeSlug(value);
    if (!slug) return [];
    if (slug === "candy_and_chocolate" || slug === "candy_chocolate") return ["Candy"];
    return splitCombinedMetaValues(value);
  };

  const snackTypeValuesFor = (product) => {
    const explicitValues = [
      ...splitCombinedMetaValues(product.snackTypes),
      ...splitCombinedMetaValues(product.snackType),
      ...splitCombinedMetaValues(product.snack_type),
      ...splitCombinedMetaValues(product?.metafields?.snack_swipe?.snack_type),
      ...splitCombinedMetaValues(product?.metafields?.snack_swipe?.snack_type?.value),
      ...splitCombinedMetaValues(product?.metafields?.snack_swipe?.snack_types),
      ...splitCombinedMetaValues(product?.metafields?.snack_swipe?.snack_types?.value),
      ...splitCombinedMetaValues(product?.metafields?.["snack_swipe.snack_type"]),
      ...splitCombinedMetaValues(product?.metafields?.["snack_swipe.snack_types"])
    ];
    const explicit = uniqueCanonicalValues(explicitValues, canonicalSnackTypeFor);
    if (explicit.length) return explicit;

    const values = [
      ...fallbackSnackTypeMetaValues(product.productType),
      ...fallbackSnackTypeMetaValues(product.type)
    ];
    const fallback = classFor(product);
    if (isUsefulMetaValue(fallback)) values.push(...fallbackSnackTypeMetaValues(fallback));
    return uniqueCanonicalValues(values, canonicalSnackTypeFor);
  };

  const iconNameForMetaValue = (value) => {
    const key = normalizeSlug(value);
    const text = lower(value);
    if (filterIconPaths[key]) return key;
    if (text.includes("drink") || text.includes("soda") || text.includes("beverage")) return "drinks";
    if (text.includes("chip") || text.includes("crisp") || text.includes("pretzel")) return "chips";
    if (text.includes("cookie") || text.includes("biscuit")) return "cookies";
    if (text.includes("gummy") || text.includes("gummies")) return "gummies";
    if (text.includes("candy")) return "candy";
    if (text.includes("chocolate")) return "chocolate";
    if (text.includes("freeze")) return "freeze_dried";
    if (text.includes("sweet")) return "sweet";
    if (text.includes("salty")) return "salty";
    if (text.includes("sour")) return "sour";
    if (text.includes("spicy")) return "spicy";
    if (text.includes("savory") || text.includes("savoury")) return "savory";
    return "other";
  };

  const tasteTypeItemsFor = (product) => {
    const typeItems = snackTypeValuesFor(product).map((value) => ({
      label: cleanLabel(value),
      icon: iconNameForMetaValue(value),
      kind: "type"
    }));
    const flavorValues = uniqueCanonicalValues([
      ...splitCombinedMetaValues(product.flavorProfiles),
      ...splitCombinedMetaValues(product.flavorProfile),
      ...splitCombinedMetaValues(product.flavor_profile),
      ...splitCombinedMetaValues(product?.metafields?.snack_swipe?.flavor_profiles),
      ...splitCombinedMetaValues(product?.metafields?.snack_swipe?.flavor_profiles?.value),
      ...flavorProfileTags(product)
    ], canonicalFlavorFor);
    const flavorItems = flavorValues.map((value) => ({
      label: cleanLabel(value),
      icon: iconNameForMetaValue(value),
      kind: "taste"
    }));
    const seen = new Set();
    const items = [...typeItems, ...flavorItems].filter((item) => {
      const key = normalizeSlug(item.label);
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
    if (items.length <= 6) return items;
    return [
      ...items.slice(0, 5),
      {
        label: `+${items.length - 5} more`,
        icon: "other",
        kind: "more"
      }
    ];
  };

  const missionDescriptionFor = (mission) => {
    const copy = {
      under_5: "Value snack.",
      sale: "Deal in orbit.",
      new: "Fresh drops in your orbit.",
      staff: "Team favorite.",
      staff_picks: "Team favorite.",
      best: "Customer favorite.",
      best_sellers: "Customer favorite.",
      last_chance: "Selling out soon.",
      international: "Imported snack."
    };
    return copy[mission?.key] || "Worth a look.";
  };

  const isUnderFive = (product) => Number(product.priceCents || 0) > 0 && Number(product.priceCents || 0) <= 500;

  const filterIconNameForButton = (button) => {
    return button.dataset.gsIcon
      || button.dataset.gsMission
      || button.dataset.gsSnackType
      || button.dataset.gsFilter
      || "other";
  };

  const hydrateFilterIcons = (root) => {
    root.querySelectorAll("[data-gs-ui-icon]").forEach((node) => {
      const name = node.dataset.gsUiIcon;
      node.innerHTML = filterIconSvg(name, "gs-swipe-filter__ui-svg");
    });

    root.querySelectorAll(".gs-swipe-filter__section-icon[data-gs-icon], .gs-swipe-filter__section-chevron[data-gs-icon]").forEach((node) => {
      node.innerHTML = filterIconSvg(node.dataset.gsIcon, "gs-swipe-filter__section-svg");
    });

    root.querySelectorAll(".gs-swipe-filter__row button").forEach((button) => {
      if (button.dataset.gsIconHydrated === "true") return;
      const label = normalize(button.textContent);
      const icon = document.createElement("span");
      icon.className = "gs-swipe-filter__option-icon";
      if (button.dataset.gsCountry) {
        icon.classList.add("gs-swipe-filter__option-icon--flag");
        icon.textContent = button.dataset.symbol || "";
      } else {
        icon.innerHTML = filterIconSvg(filterIconNameForButton(button), "gs-swipe-filter__option-svg");
      }

      const labelNode = document.createElement("span");
      labelNode.className = "gs-swipe-filter__option-label";
      labelNode.textContent = label;
      if (!button.hasAttribute("aria-label")) {
        button.setAttribute("aria-label", `Toggle ${label} filter`);
      }

      const check = document.createElement("span");
      check.className = "gs-swipe-filter__check";
      check.innerHTML = filterIconSvg("check", "gs-swipe-filter__check-svg");

      button.textContent = "";
      button.append(icon, labelNode, check);
      button.dataset.gsIconHydrated = "true";
    });
  };

  const productIsDeckEligible = (product) => {
    if (!product || !product.variantId) return false;
    const enabled = lower(product.enabled);
    const visibility = normalizeSlug(product.visibility || product.swipeVisibility);
    const deck = normalizeSlug(product.deck);
    return product.enabled !== false
      && enabled !== "false"
      && visibility !== "hide"
      && visibility !== "hidden"
      && deck !== "hidden";
  };

  const productHasValidPrice = (product) => {
    if (!product) return false;
    const cents = Number(product.priceCents || 0);
    const numericPrice = Number(product.numericPrice || 0);
    if (Number.isFinite(cents) && cents > 0) return true;
    if (Number.isFinite(numericPrice) && numericPrice > 0) return true;
    return Boolean(priceFor(product));
  };

  const productHasPurchasableVariant = (product) => {
    if (!product || !product.variantId) return false;
    return product.available !== false
      && product.availableForSale !== false
      && product.variantAvailable !== false
      && product.inventoryAvailable !== false
      && product.inStock !== false;
  };

  const productIsPurchasable = (product) => (
    productIsDeckEligible(product)
    && productHasPurchasableVariant(product)
    && productHasValidPrice(product)
  );

  const loadProducts = (root) => {
    const node = root.querySelector("[data-gs-products]");
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || "[]").filter(productIsDeckEligible);
    } catch (error) {
      console.warn("Snack Swipe could not parse product data", error);
      return [];
    }
  };

  const initSwipe = (root) => {
    const allProducts = loadProducts(root);
    const swipeDeckProducts = allProducts.filter(productIsPurchasable);
    let products = swipeDeckProducts.slice();
    let index = 0;
    let activeFilters = [];
    let activeCountries = [];
    let activeSnackTypes = [];
    let activeMissions = [];
    let draftFilters = [];
    let draftCountries = [];
    let draftSnackTypes = [];
    let draftMissions = [];
    let detailsOpen = false;
    let isAnimating = false;
    let lastDecisionAt = 0;
    let lastSwipe = null;
    let localCartCount = 0;
    let tourStep = 0;
    let gestureDemoTimer = null;
    let gestureDemoMotionFrame = null;
    let gestureDemoMotionStart = 0;
    let filterTipTimer = null;
    let lastFilterApplyAt = 0;
    let filterApplyShieldUntil = 0;
    let previousBodyOverflow = "";
    let previousDocumentOverflow = "";
    let isDestroyed = false;
    const cleanupCallbacks = [];
    let swipeSessionId = "";
    let hasStartedSession = false;
    let lastViewedEventKey = "";
    let skippedCount = 0;
    let savedDecisionCount = 0;
    let addedToCartCount = 0;
    let addToCartClickCount = 0;
    let addToCartSuccessCount = 0;
    let addToCartSuccessQuantity = 0;
    let detailOpenCount = 0;
    let filtersOpenCount = 0;
    let filtersAppliedCount = 0;
    let savedListOpened = false;
    let savedListOpenCount = 0;
    let cardActionCount = 0;
    let sessionSummaryTracked = false;
    let deckCompletedTracked = false;
    let filterTipEngagementCount = 0;
    let savedListSelectedIds = new Set();
    let savedListQuantities = {};
    let savedListAddingIds = new Set();
    let savedListAddedIds = new Set();
    let savedListToastTimer = null;
    let lastRemovedSaved = null;
    let detailsProductOverride = null;
    const sessionStartedAt = Date.now();
    const productsSeenKeys = new Set();
    const imageErrorKeys = new Set();
    const inputTypeCounts = {
      swipe: 0,
      drag: 0,
      button: 0,
      keyboard: 0,
      unknown: 0
    };
    const filterTipEngagementThreshold = 3;
    const storageKey = root.dataset.storageKey || "gsSnackSwipeShortlist:v1";
    const introKey = `${storageKey}:introSeen`;
    const gestureIntroKey = `${storageKey}:gestureIntroSeen:v9`;
    const filterTipKey = `${storageKey}:filterTipSeen:v3`;

    const listen = (target, type, handler, options) => {
      if (!target || typeof target.addEventListener !== "function") return;
      target.addEventListener(type, handler, options);
      cleanupCallbacks.push(() => target.removeEventListener(type, handler, options));
    };

    const destroySwipe = () => {
      if (isDestroyed) return;
      isDestroyed = true;
      cleanupCallbacks.splice(0).reverse().forEach((cleanup) => {
        try {
          cleanup();
        } catch (_error) {
          // Best-effort cleanup; the overlay can still close if one listener is already gone.
        }
      });
      window.clearTimeout(gestureDemoTimer);
      window.clearTimeout(filterTipTimer);
      if (gestureDemoMotionFrame) window.cancelAnimationFrame(gestureDemoMotionFrame);
      document.documentElement.classList.remove("gs-swipe-details-lock");
      document.body?.classList.remove("gs-swipe-details-lock");
      if (els.filterOverlay && !els.filterOverlay.hidden) {
        document.body.style.overflow = previousBodyOverflow;
        document.documentElement.style.overflow = previousDocumentOverflow;
      }
      root.classList.remove("is-filter-open");
      root.removeAttribute("data-initialized");
      delete root.__gsSwipeDestroy;
    };

    root.__gsSwipeDestroy = destroySwipe;
    const tourSteps = [
      {
        target: "[data-gs-card]",
        kicker: "Swipe Mode",
        title: "Snack Swipe",
        copy: "Swipe through snacks fast. Save anything that catches your eye, skip what does not, and come back to your saved list when you are ready to review your picks."
      },
      {
        target: "[data-gs-card]",
        kicker: "Snack Intel",
        title: "Get The Details",
        copy: "Tap the snack card to open Snack Intel. You will see a quick description, country, snack type, reviews, mission badges, and full product notes without leaving Swipe Mode."
      },
      {
        target: "[data-gs-toggle-filters]",
        kicker: "Pick Your Lane",
        title: "Filter Fast",
        copy: "Use filters when you want to narrow the deck by flavor profile, country, snack type, or mission. Keep them closed when you just want to swipe."
      },
      {
        target: "[data-gs-open-list]",
        kicker: "Your Shortlist",
        title: "Save Your Picks",
        copy: "Tap Save or swipe right to keep snacks for later. Open your saved list anytime to review your picks or add them to cart."
      }
    ];

    const els = {
      card: root.querySelector("[data-gs-card]"),
      empty: root.querySelector("[data-gs-empty]"),
      image: root.querySelector("[data-gs-image]"),
      title: root.querySelector("[data-gs-title]"),
      productClass: root.querySelector("[data-gs-class]"),
      origin: root.querySelector("[data-gs-origin]"),
      price: root.querySelector("[data-gs-price]"),
      priceNote: root.querySelector("[data-gs-price-note]"),
      addPrice: root.querySelector("[data-gs-add-price]"),
      addCurrent: root.querySelector("[data-gs-add-current]"),
      review: root.querySelector("[data-gs-review]"),
      meta: root.querySelector("[data-gs-meta]"),
      intel: root.querySelector("[data-gs-intel]"),
      match: root.querySelector("[data-gs-match]"),
      cardPrompt: root.querySelector("[data-gs-card-prompt]"),
      unavailableActions: root.querySelector("[data-gs-unavailable-actions]"),
      unavailableShow: root.querySelector("[data-gs-unavailable-show]"),
      merchBadges: root.querySelector("[data-gs-merch-badges]"),
      cardStack: root.querySelector("[data-gs-card-stack]"),
      previewNext: root.querySelector("[data-gs-preview-next]"),
      previewSecondary: root.querySelector("[data-gs-preview-secondary]"),
      previewNextName: root.querySelector("[data-gs-preview-next-name]"),
      previewSecondaryName: root.querySelector("[data-gs-preview-secondary-name]"),
      description: root.querySelector("[data-gs-description]"),
      details: root.querySelector("[data-gs-details]"),
      detailsTitle: root.querySelector("[data-gs-details-title]"),
      detailsSummary: root.querySelector("[data-gs-details-summary]"),
      detailsStatus: root.querySelector("[data-gs-details-status]"),
      detailsMetaStrip: root.querySelector("[data-gs-details-meta-strip]"),
      detailsImage: root.querySelector("[data-gs-details-image]"),
      detailsFacts: root.querySelector("[data-gs-details-facts]"),
      detailsMissions: root.querySelector("[data-gs-details-missions]"),
      detailsMissionRow: root.querySelector("[data-gs-details-mission-row]"),
      detailsNotes: root.querySelector("[data-gs-details-notes]"),
      detailsClose: root.querySelector("[data-gs-details-close]"),
      detailsLink: root.querySelector("[data-gs-details-link]"),
      detailsAdd: root.querySelector("[data-gs-details-add]"),
      detailsPrice: root.querySelector("[data-gs-details-price]"),
      filterToggle: root.querySelector("[data-gs-toggle-filters]"),
      filterTip: root.querySelector("[data-gs-filter-tip]"),
      filterTipClose: root.querySelectorAll("[data-gs-close-filter-tip]"),
      filterTipOpen: root.querySelector("[data-gs-open-filters-from-tip]"),
      filterOverlay: root.querySelector("[data-gs-filter-overlay]"),
      applyFiltersButton: root.querySelector("[data-gs-apply-filters]"),
      filterResultCount: root.querySelector("[data-gs-filter-result-count]"),
      filterCriteriaCount: root.querySelector("[data-gs-filter-criteria-count]"),
      route: root.querySelector("[data-gs-route]"),
      activeChips: root.querySelector("[data-gs-active-chips]"),
      routeEdit: root.querySelector("[data-gs-edit-route]"),
      undo: root.querySelector("[data-gs-undo]"),
      emptyActions: root.querySelector("[data-gs-empty-actions]"),
      productLinks: root.querySelectorAll("[data-gs-product-link]"),
      progressText: root.querySelector("[data-gs-progress-text]"),
      progressBar: root.querySelector("[data-gs-progress-bar]"),
      status: root.querySelector("[data-gs-status]"),
      reaction: root.querySelector("[data-gs-reaction]"),
      intro: root.querySelector("[data-gs-intro]"),
      gestureDemo: root.querySelector("[data-gs-gesture-demo]"),
      gestureDemoDismiss: root.querySelector("[data-gs-dismiss-gesture-demo]"),
      gestureDemoImage: root.querySelector("[data-gs-gesture-demo-image]"),
      gestureDemoMotionCard: root.querySelector(".gs-swipe-gesture-demo__motion-card"),
      gestureDemoProductName: root.querySelector("[data-gs-gesture-demo-product-name]"),
      gestureDemoPrice: root.querySelector("[data-gs-gesture-demo-price]"),
      gestureDemoSkipToast: root.querySelector(".gs-swipe-gesture-demo__toast--skip"),
      gestureDemoSaveToast: root.querySelector(".gs-swipe-gesture-demo__toast--save"),
      decisionFeedback: root.querySelector("[data-gs-decision-feedback]"),
      tourSpotlight: root.querySelector("[data-gs-tour-spotlight]"),
      tourKicker: root.querySelector("[data-gs-tour-kicker]"),
      tourTitle: root.querySelector("[data-gs-tour-title]"),
      tourCopy: root.querySelector("[data-gs-tour-copy]"),
      tourNext: root.querySelector("[data-gs-tour-next]"),
      tourSteps: root.querySelector("[data-gs-tour-steps]"),
      list: root.querySelector("[data-gs-list]"),
      listItems: root.querySelector("[data-gs-list-items]"),
      shortlistTotal: root.querySelector("[data-gs-shortlist-total]"),
      listCta: root.querySelector("[data-gs-list-cta]"),
      listFooter: root.querySelector("[data-gs-list-footer]"),
      listToast: root.querySelector("[data-gs-list-toast]"),
      counts: root.querySelectorAll("[data-gs-shortlist-count]"),
      cartCounts: root.querySelectorAll("[data-gs-cart-count]")
    };

    if (els.details && els.details.parentElement !== root) {
      root.appendChild(els.details);
    }

    hydrateFilterIcons(root);

    const launchParams = new URLSearchParams(window.location.search);
    const paramValue = (...names) => {
      for (const name of names) {
        const datasetKey = name.replace(/_([a-z])/g, (_match, char) => char.toUpperCase());
        if (root.dataset[datasetKey]) return root.dataset[datasetKey];
        const value = launchParams.get(name);
        if (value) return value;
      }
      return "";
    };
    const launchProductHandle = normalizeSlug(paramValue("swipe_product", "product"));
    const launchView = normalizeSlug(paramValue("swipe_view", "view"));
    const launchIntroParam = lower(paramValue("swipe_intro", "showIntro"));
    const launchIntroMode = ["1", "true", "force", "yes"].includes(launchIntroParam)
      ? "force"
      : ["0", "false", "skip", "suppress", "no"].includes(launchIntroParam)
        ? "suppress"
        : "";
    const launchDebugParam = lower(paramValue("swipe_debug"));
    const isDebugMode = ["1", "true", "yes", "on"].includes(launchDebugParam);
    const launchList = (...names) => paramValue(...names)
      .split(/[|,]/)
      .map(normalizeSlug)
      .filter(Boolean);
    activeFilters = launchList("swipe_filter", "filter");
    activeCountries = launchList("swipe_country", "country");
    activeSnackTypes = launchList("swipe_type", "swipe_snack_type", "type");
    activeMissions = launchList("swipe_mission", "mission");
    draftFilters = activeFilters.slice();
    draftCountries = activeCountries.slice();
    draftSnackTypes = activeSnackTypes.slice();
    draftMissions = activeMissions.slice();
    let launchProductPending = Boolean(launchProductHandle);
    let launchIntelPending = launchView === "intel" && Boolean(launchProductHandle);

    const isPortalMode = launchParams.get("portal") === "1" || root.dataset.gsPortalMode === "true";
    if (isPortalMode) root.classList.add("is-portal-mode");
    if (isPortalMode && els.intro) {
      els.intro.hidden = true;
      localStorage.setItem(introKey, "true");
    }

    const postPortalMessage = (type, payload = {}) => {
      if (!isPortalMode) return;
      if (!window.parent || window.parent === window) {
        window.dispatchEvent(new CustomEvent(type, { detail: payload }));
        return;
      }
      try {
        window.parent.postMessage({
          type,
          ...payload
        }, window.location.origin);
      } catch (error) {
        // Parent messaging is a progressive enhancement for the overlay shell.
      }
    };

    let detailsReturnFocus = null;
    let filterReturnFocus = null;
    let listReturnFocus = null;
    let introReturnFocus = null;
    let gestureReturnFocus = null;
    const focusableSelector = [
      "a[href]",
      "button:not([disabled])",
      "input:not([disabled])",
      "select:not([disabled])",
      "textarea:not([disabled])",
      "[tabindex]:not([tabindex='-1'])",
      "[contenteditable='true']"
    ].join(",");

    const elementDescriptor = (element) => [
      element?.id || "",
      typeof element?.className === "string" ? element.className : "",
      element?.getAttribute?.("data-rebuy-component") || "",
      element?.getAttribute?.("data-smartcart") || "",
      element?.getAttribute?.("data-smart-cart") || ""
    ].join(" ").toLowerCase();

    const isExternalCartElement = (element) => {
      const descriptor = elementDescriptor(element);
      return descriptor.includes("rebuy")
        || descriptor.includes("smartcart")
        || descriptor.includes("smart-cart")
        || descriptor.includes("smart_cart");
    };

    const isElementVisible = (element) => {
      if (!element || element.hidden) return false;
      const style = window.getComputedStyle(element);
      return style.display !== "none" && style.visibility !== "hidden" && element.getClientRects().length > 0;
    };

    const isInExternalCart = (element) => {
      let current = element && element.nodeType === 1 ? element : element?.parentElement;
      while (current && current !== document.body) {
        if (isExternalCartElement(current)) return true;
        current = current.parentElement;
      }
      return false;
    };

    const externalCartIsActive = () => Array.from(document.body?.children || [])
      .some((child) => isExternalCartElement(child) && isElementVisible(child));

    const currentFocusAnchor = (fallback = els.card) => (
      root.contains(document.activeElement) && isElementVisible(document.activeElement)
        ? document.activeElement
        : fallback
    );

    const focusSafely = (element) => {
      if (!element || typeof element.focus !== "function" || !isElementVisible(element)) return false;
      element.focus({ preventScroll: true });
      return true;
    };

    const restoreFocusTo = (element, fallback = els.card, options = {}) => {
      if (options.restoreFocus === false) return;
      window.setTimeout(() => {
        if (isDestroyed) return;
        const target = isElementVisible(element) ? element : fallback;
        const layer = activeModalLayer();
        if (layer && target && !layer.node.contains(target)) return;
        if (!focusSafely(target)) focusSafely(fallback);
      }, 0);
    };

    const focusableWithin = (container) => {
      if (!container) return [];
      return Array.from(container.querySelectorAll(focusableSelector))
        .filter((element) => !element.disabled && element.getAttribute("aria-hidden") !== "true" && isElementVisible(element));
    };

    const focusFirstWithin = (container, fallback) => {
      const target = focusableWithin(container)[0] || fallback;
      focusSafely(target);
    };

    const trapFocusWithin = (container, event) => {
      if (!container || event.key !== "Tab" || externalCartIsActive() || isInExternalCart(event.target)) return;
      const focusable = focusableWithin(container);
      if (!focusable.length) {
        event.preventDefault();
        focusSafely(container);
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const active = document.activeElement;
      if (event.shiftKey && active === first) {
        event.preventDefault();
        focusSafely(last);
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        focusSafely(first);
      } else if (!container.contains(active)) {
        event.preventDefault();
        focusSafely(first);
      }
    };

    const activeModalLayer = () => {
      if (detailsOpen && els.details && !els.details.hidden) {
        return { node: els.details, close: () => toggleDetails(false) };
      }
      if (els.gestureDemo && !els.gestureDemo.hidden) {
        return { node: els.gestureDemo, close: () => closeGestureDemo("escape") };
      }
      if (els.intro && !els.intro.hidden) {
        return { node: els.intro, close: () => closeIntro("skipped") };
      }
      if (els.list && !els.list.hidden) {
        return { node: els.list, close: () => closeList() };
      }
      if (els.filterOverlay && !els.filterOverlay.hidden) {
        return { node: els.filterOverlay, close: () => closeFilterOverlay() };
      }
      return null;
    };

    const debugLog = (eventName, payload = {}) => {
      if (!isDebugMode) return;
      console.info(`[Snack Swipe App] ${eventName}`, payload);
    };

    const notifyPortalPanelState = () => {
      const panelOpen = Boolean(
        detailsOpen ||
        (els.filterOverlay && !els.filterOverlay.hidden) ||
        (els.list && !els.list.hidden) ||
        (els.intro && !els.intro.hidden) ||
        (els.gestureDemo && !els.gestureDemo.hidden)
      );

      postPortalMessage("gs-snack-swipe:panel-state", { open: panelOpen });
    };

    const notifyPortalCartUpdated = (payload = {}) => {
      debugLog("portal cart-updated", payload);
      postPortalMessage("gs-snack-swipe:cart-updated", payload);
    };

    if (isPortalMode) {
        const topbar = root.querySelector(".gs-swipe__topbar");
        if (topbar && !topbar.querySelector("[data-gs-exit-portal]")) {
          const exitButton = document.createElement("button");
          exitButton.className = "gs-swipe__portal-exit";
          exitButton.type = "button";
          exitButton.dataset.gsExitPortal = "";
          exitButton.setAttribute("aria-label", "Close swipe mode");
          exitButton.textContent = "";
          exitButton.title = "Close swipe mode";
          exitButton.addEventListener("click", (event) => {
            settleFilterButtonFocus(event.currentTarget, event);
            postPortalMessage("gs-snack-swipe:exit");
          });
          topbar.prepend(exitButton);
        }
      }


    const getSaved = () => {
      try {
        return JSON.parse(localStorage.getItem(storageKey) || "[]");
      } catch (error) {
        return [];
      }
    };

    const setSaved = (items) => {
      localStorage.setItem(storageKey, JSON.stringify(items));
      renderShortlist();
    };

    const productSessionKey = (product) => normalize(product?.variantId || product?.id || product?.handle || product?.title);
    const addedToCartSessionKey = `${storageKey}:addedToCart:v1`;
    const swipedSessionKey = `${storageKey}:swiped:v1`;

    const readSessionProductKeys = (key) => {
      try {
        return new Set(JSON.parse(sessionStorage.getItem(key) || "[]"));
      } catch (error) {
        return new Set();
      }
    };

    const writeSessionProductKeys = (key, values) => {
      try {
        sessionStorage.setItem(key, JSON.stringify([...values]));
      } catch (error) {
        // Session exclusion is helpful but non-critical in restricted browsers.
      }
    };

    let addedToCartProductKeys = readSessionProductKeys(addedToCartSessionKey);
    let swipedProductKeys = readSessionProductKeys(swipedSessionKey);

    const launchProductMatches = (product) => {
      if (!launchProductHandle || !product) return false;
      return normalizeSlug(product.handle) === launchProductHandle
        || normalizeSlug(product.id) === launchProductHandle
        || normalizeSlug(product.variantId) === launchProductHandle;
    };

    const productHasLaunchOverride = (product) => launchProductPending && launchProductMatches(product);

    const isProductExcludedForSession = (product) => {
      const key = productSessionKey(product);
      return Boolean(
        key
        && !productHasLaunchOverride(product)
        && (addedToCartProductKeys.has(key) || swipedProductKeys.has(key))
      );
    };

    const markProductsSwipedForSession = (items) => {
      const keys = items.map(productSessionKey).filter(Boolean);
      if (!keys.length) return;
      keys.forEach((key) => swipedProductKeys.add(key));
      writeSessionProductKeys(swipedSessionKey, swipedProductKeys);
    };

    const unmarkProductsSwipedForSession = (items) => {
      const keys = items.map(productSessionKey).filter(Boolean);
      if (!keys.length) return;
      keys.forEach((key) => swipedProductKeys.delete(key));
      writeSessionProductKeys(swipedSessionKey, swipedProductKeys);
    };

    const findLaunchProduct = () => {
      if (!launchProductHandle) return null;
      return allProducts.find(launchProductMatches) || null;
    };

    const currentProduct = () => products[index];
    const detailProduct = () => detailsProductOverride || currentProduct();

    const isDemoMode = () => root.dataset.localPreview === "true" || root.dataset.demoProducts === "true" || window.location.protocol === "file:";

    const createSessionId = () => {
      if (window.crypto && typeof window.crypto.randomUUID === "function") return window.crypto.randomUUID();
      return `swipe_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    };

    const getSessionId = () => {
      if (!swipeSessionId) swipeSessionId = createSessionId();
      return swipeSessionId;
    };

    const deckId = () => {
      const parts = [
        activeFilters.length ? `flavor_${activeFilters.join("-")}` : "",
        activeCountries.length ? `country_${activeCountries.join("-")}` : "",
        activeSnackTypes.length ? `snack_type_${activeSnackTypes.join("-")}` : "",
        activeMissions.length ? `mission_${activeMissions.join("-")}` : ""
      ].filter(Boolean);
      if (parts.length) return `route_${parts.join("__")}`;
      return isDemoMode() ? "demo_products" : "collection";
    };

    const deckSource = () => {
      if (root.dataset.localPreview === "true") return "local_preview";
      if (root.dataset.demoProducts === "true") return "demo_page";
      return root.dataset.deckSource || "page";
    };

    const pipeList = (values) => {
      return (Array.isArray(values) ? values : listValues(values))
        .map(normalizeSlug)
        .filter(Boolean)
        .join("|");
    };

    const selectedFilterValuesFor = (route = {}) => {
      const filters = route.filters || activeFilters;
      const countries = route.countries || activeCountries;
      const snackTypes = route.snackTypes || activeSnackTypes;
      const missions = route.missions || activeMissions;
      return [
        ...countries.map((value) => ["country", value]),
        ...filters.map((value) => ["flavor", value]),
        ...snackTypes.map((value) => ["type", value]),
        ...missions.map((value) => ["mission", value])
      ]
        .map(([group, value]) => `${group}:${normalizeSlug(value)}`)
        .filter((value) => !value.endsWith(":"));
    };

    const selectedRouteParams = (route = {}) => {
      const filters = route.filters || activeFilters;
      const countries = route.countries || activeCountries;
      const snackTypes = route.snackTypes || activeSnackTypes;
      const missions = route.missions || activeMissions;
      const selectedValues = selectedFilterValuesFor(route);
      const groups = [
        countries.length ? `country:${pipeList(countries)}` : "",
        filters.length ? `flavor:${pipeList(filters)}` : "",
        snackTypes.length ? `type:${pipeList(snackTypes)}` : "",
        missions.length ? `mission:${pipeList(missions)}` : ""
      ].filter(Boolean);

      return {
        selected_flavors: pipeList(filters),
        selected_countries: pipeList(countries),
        selected_snack_types: pipeList(snackTypes),
        selected_missions: pipeList(missions),
        selected_filter_values: selectedValues.join("|"),
        selected_group_count: groups.length,
        selected_value_count: selectedValues.length,
        filter_combo_key: groups.join("__") || "none",
        filter_logic: "or_within_group_and_across_groups"
      };
    };

    const deviceType = () => {
      const width = window.innerWidth || document.documentElement.clientWidth || 0;
      if (width < 768) return "mobile";
      if (width < 1100) return "tablet";
      return "desktop";
    };

    const baseTrackingParams = () => ({
      snack_swipe_version: root.dataset.swipeVersion || SNACK_SWIPE_ANALYTICS_VERSION,
      swipe_surface: isPortalMode ? "overlay" : "standalone",
      swipe_entrypoint: launchProductHandle ? "product_page" : "storefront",
      deck_id: deckId(),
      deck_source: deckSource(),
      deck_size: products.length,
      theme_name: root.dataset.themeName || window.Shopify?.theme?.name || "",
      theme_version: root.dataset.themeVersion || window.Shopify?.theme?.theme_store_id || "",
      device_type: deviceType(),
      viewport_width: window.innerWidth || document.documentElement.clientWidth || 0,
      viewport_height: window.innerHeight || document.documentElement.clientHeight || 0,
      page_pathname: window.location.pathname,
      demo_mode: isDemoMode(),
      portal_mode: isPortalMode,
      overlay_mode: isPortalMode ? "dom_overlay" : "standalone"
    });

    const ANALYTICS_NEUTRAL_PARAMS = {
      product_id: "not_applicable",
      variant_id: "not_applicable",
      product_handle: "not_applicable",
      product_title: "not_applicable",
      product_position: 0,
      product_price_bucket: "unknown",
      available: false,
      availability_status: "not_applicable",
      product_availability_status: "not_applicable",
      country: "not_applicable",
      product_country: "not_applicable",
      product_type: "not_applicable",
      snack_type: "not_applicable",
      flavor_profiles: "none",
      product_flavor_profiles: "none",
      missions: "none",
      product_missions: "none",
      card_badges: "none",
      product_badges: "none",
      bundle_flag: false,
      bundle_app: "none",
      review_rating: 0,
      review_count: 0,
      has_image: false,
      image_source: "not_applicable",
      selected_flavors: "none",
      selected_countries: "none",
      selected_snack_types: "none",
      selected_missions: "none",
      selected_filter_values: "none",
      selected_group_count: 0,
      selected_value_count: 0,
      filter_combo_key: "none",
      filter_logic: "none",
      swipe_action: "none",
      input_type: "none",
      source: "none",
      result: "none",
      cart_action: "none",
      cart_source: "none",
      cart_result: "none",
      prior_swipe_action: "none",
      item_count: 0,
      quantity: 0,
      value: 0,
      estimated_value: 0,
      items_added_count: 0,
      rebuy_drawer_opened: false
    };

    const productImageSourceFor = (product) => {
      if (!product) return "missing";
      if (normalize(product.cutoutImage)) return "cutout";
      if (normalize(product.image)) return "product_image";
      if (normalize(product.shopifyImage)) return "shopify_image";
      return "missing";
    };

    const productPriceValue = (product) => {
      const numericPrice = Number(product?.numericPrice || 0);
      if (Number.isFinite(numericPrice) && numericPrice > 0) return numericPrice;
      const cents = Number(product?.priceCents || 0);
      return Number.isFinite(cents) && cents > 0 ? cents / 100 : 0;
    };

    const productPriceBucket = (product) => {
      const price = productPriceValue(product);
      if (!price) return "unknown";
      if (price < 5) return "under_5";
      if (price < 10) return "5_to_9_99";
      if (price < 20) return "10_to_19_99";
      if (price < 35) return "20_to_34_99";
      return "35_plus";
    };

    const productTrackingParams = (product = currentProduct()) => {
      const safeProduct = product || {};
      const review = reviewFor(safeProduct);
      const availability = availabilityFor(safeProduct);
      const productKey = productSessionKey(safeProduct);
      const productIndex = products.findIndex((item) => productSessionKey(item) === productKey);
      const flavorProfiles = flavorProfileTags(safeProduct).map(normalizeSlug).filter(Boolean);
      const missions = missionBadgesFor(safeProduct).map((mission) => mission.key).filter(Boolean);
      const cardBadges = merchBadgesFor(safeProduct).map((badge) => badge.slug).filter(Boolean);
      const snackType = safeProduct.productType || classFor(safeProduct);
      const productTextValue = productText(safeProduct);
      const bundleFlag = Boolean(
        safeProduct.bundleFlag
        || safeProduct.isBundle
        || lower(snackType).includes("bundle")
        || productTextValue.includes("bundle")
      );

      return {
        ...baseTrackingParams(),
        ...selectedRouteParams(),
        product_id: safeProduct.id,
        variant_id: safeProduct.variantId,
        product_handle: safeProduct.handle,
        product_title: smartTruncate(displayTitleFor(safeProduct) || safeProduct.title, 100),
        product_full_title: safeProduct.title,
        product_position: productIndex >= 0 ? productIndex + 1 : index + 1,
        price: productPriceValue(safeProduct),
        product_price_cents: Number(safeProduct.priceCents || 0),
        product_price_bucket: productPriceBucket(safeProduct),
        available: productIsPurchasable(safeProduct),
        availability_status: availability.status,
        product_availability_status: availability.status,
        country: countryFor(safeProduct),
        product_country: countryFor(safeProduct),
        product_type: snackType,
        snack_type: snackType,
        flavor_profiles: flavorProfiles.join("|"),
        product_flavor_profiles: flavorProfiles.join("|"),
        missions: missions.join("|"),
        product_missions: missions.join("|"),
        card_badges: cardBadges.join("|"),
        product_badges: cardBadges.join("|"),
        bundle_flag: bundleFlag,
        bundle_app: safeProduct.bundleApp || safeProduct.bundle_app || "",
        review_rating: review?.rating || 0,
        review_count: review?.count || 0,
        has_image: Boolean(productImageFor(safeProduct)),
        image_source: productImageSourceFor(safeProduct)
      };
    };

    const sanitizeAnalyticsValue = (key, value) => {
      if (value === undefined || value === null || value === "") return undefined;
      if (key === "items") return value;
      if (Array.isArray(value)) return value.map(normalize).filter(Boolean).join("|");
      if (typeof value === "object") {
        try {
          return JSON.stringify(value);
        } catch (_error) {
          return undefined;
        }
      }
      return value;
    };

    const sanitizeAnalyticsPayload = (payload) => {
      return Object.entries(payload).reduce((clean, [key, value]) => {
        const sanitized = sanitizeAnalyticsValue(key, value);
        if (sanitized !== undefined) clean[key] = sanitized;
        return clean;
      }, {});
    };

    const isNeutralAnalyticsValue = (value) => (
      value === undefined
      || value === null
      || value === ""
      || value === "none"
      || value === "not_applicable"
    );

    const normalizeSwipeAnalyticsParams = (eventName, params = {}) => {
      const normalized = {
        ...baseTrackingParams(),
        ...ANALYTICS_NEUTRAL_PARAMS,
        ...params
      };
      if (!normalized.swipe_surface) normalized.swipe_surface = isPortalMode ? "overlay" : "standalone";
      if (!normalized.swipe_entrypoint) normalized.swipe_entrypoint = launchProductHandle ? "product_page" : "storefront";
      if (normalized.action && isNeutralAnalyticsValue(normalized.swipe_action)) normalized.swipe_action = normalized.action;
      if (normalized.source && eventName.includes("add_to_cart") && isNeutralAnalyticsValue(normalized.cart_action)) normalized.cart_action = normalized.source;
      if (normalized.result && isNeutralAnalyticsValue(normalized.cart_result)) normalized.cart_result = normalized.result;
      if (normalized.product_position && !normalized.card_position) normalized.card_position = normalized.product_position;
      if (normalized.selected_value_count !== undefined && !normalized.filter_count) normalized.filter_count = normalized.selected_value_count;
      if ((normalized.items_added_count === undefined || normalized.items_added_count === 0) && Number(normalized.quantity) > 0) {
        normalized.items_added_count = normalized.quantity;
      }
      [
        "swipe_session_id",
        "page_location",
        "product_full_title",
        "price",
        "product_price_cents"
      ].forEach((key) => {
        delete normalized[key];
      });
      return normalized;
    };

    const safeErrorMessage = (error) => {
      return smartTruncate(stripHtml(error?.message || String(error || "")), 160);
    };

    const savedListContainsProduct = (product) => {
      const key = productSessionKey(product);
      if (!key) return false;
      return getSaved().some((item) => productSessionKey(item) === key);
    };

    const trackSnackSwipe = (eventName, params = {}) => {
      const hasAlias = Object.prototype.hasOwnProperty.call(SNACK_SWIPE_EVENT_ALIASES, eventName);
      const mappedEventName = hasAlias ? SNACK_SWIPE_EVENT_ALIASES[eventName] : eventName;
      if (mappedEventName === false) return;

      const ga4EventName = mappedEventName;
      const payload = sanitizeAnalyticsPayload({
        source_feature: "snack_swipe",
        snack_swipe_original_event: eventName,
        snack_swipe_event_name: ga4EventName,
        event_id: `swipe_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
        event_timestamp: new Date().toISOString(),
        ...normalizeSwipeAnalyticsParams(ga4EventName, params)
      });

      debugLog(`analytics:${ga4EventName}`, payload);
      window.dispatchEvent(new CustomEvent("snack-swipe:analytics", {
        detail: {
          event_name: ga4EventName,
          original_event_name: eventName,
          params: payload
        }
      }));
      if (isPortalMode) {
        postPortalMessage("gs-snack-swipe:analytics", {
          event_name: ga4EventName,
          original_event_name: eventName,
          params: payload
        });
        return;
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: ga4EventName,
        ...payload
      });
    };

    const trackProductAddedToCart = (product, options = {}) => {
      if (!product) return;
      const quantity = Math.max(1, Number(options.quantity || 1));
      const source = options.source || "unknown";
      const value = productPriceValue(product) * quantity;

      trackSnackSwipe("snack_swipe_product_added_to_cart", {
        ...productTrackingParams(product),
        result: "success",
        source,
        cart_source: source,
        prior_swipe_action: options.priorSwipeAction || options.prior_swipe_action || "none",
        quantity,
        item_count: 1,
        value,
        estimated_value: value,
        saved_count: options.saved_count,
        rebuy_drawer_opened: Boolean(options.rebuy_drawer_opened)
      });
    };

    const startSession = (reason = "interaction") => {
      if (hasStartedSession) return;
      hasStartedSession = true;
      trackSnackSwipe("snack_swipe_session_start", {
        ...baseTrackingParams(),
        start_reason: reason
      });
    };

    const trackProductViewed = (product) => {
      if (!product) return;
      const key = `${deckId()}:${index}:${product.variantId || product.id || product.handle}`;
      if (key === lastViewedEventKey) return;
      lastViewedEventKey = key;
      productsSeenKeys.add(productSessionKey(product) || key);
      trackSnackSwipe("snack_swipe_card_view", productTrackingParams(product));
    };

    const primaryInputType = () => {
      return Object.entries(inputTypeCounts)
        .sort((a, b) => b[1] - a[1])[0]?.[0] || "unknown";
    };

    const trackSessionSummary = (reason = "exit") => {
      if (sessionSummaryTracked) return;
      if (!hasStartedSession && !productsSeenKeys.size) return;
      sessionSummaryTracked = true;
      trackSnackSwipe("snack_swipe_session_summary", {
        ...baseTrackingParams(),
        ...selectedRouteParams(),
        summary_reason: reason,
        products_seen: productsSeenKeys.size,
        swipe_actions: cardActionCount,
        saves: savedDecisionCount,
        skips: skippedCount,
        details_opened: detailOpenCount,
        filters_opened: filtersOpenCount,
        filters_applied: filtersAppliedCount,
        saved_list_opened: savedListOpened,
        saved_list_open_count: savedListOpenCount,
        add_to_cart_clicked: addToCartClickCount > 0,
        add_to_cart_click_count: addToCartClickCount,
        add_to_cart_success_count: addToCartSuccessCount,
        add_to_cart_success_quantity: addToCartSuccessQuantity,
        duration_seconds: Math.max(0, Math.round((Date.now() - sessionStartedAt) / 1000)),
        primary_input_type: primaryInputType()
      });
    };

    const trackProductImageError = (product, imageContext = "card") => {
      const image = productImageFor(product);
      if (!product || !image) return;
      const key = `${imageContext}:${productSessionKey(product)}:${image}`;
      if (imageErrorKeys.has(key)) return;
      imageErrorKeys.add(key);
      trackSnackSwipe("snack_swipe_product_image_error", {
        ...productTrackingParams(product),
        image_url: image,
        image_context: imageContext
      });
    };

    const setStatus = (message) => {
      if (els.status) els.status.textContent = message;
    };

    const updateCartCount = () => {
      els.cartCounts.forEach((count) => {
        count.textContent = localCartCount;
      });
    };

    const updateUndo = () => {
      if (els.undo) els.undo.hidden = !lastSwipe;
    };

    const setTourStep = (stepIndex) => {
      tourStep = Math.max(0, Math.min(stepIndex, tourSteps.length - 1));
      const step = tourSteps[tourStep];
      if (els.tourKicker) els.tourKicker.textContent = step.kicker;
      if (els.tourTitle) els.tourTitle.textContent = step.title;
      if (els.tourCopy) els.tourCopy.textContent = step.copy;
      if (els.tourNext) els.tourNext.textContent = tourStep === tourSteps.length - 1 ? "Start swiping" : "Next";
      els.tourSteps?.querySelectorAll("span").forEach((dot, index) => {
        dot.classList.toggle("is-active", index === tourStep);
      });
      window.requestAnimationFrame(positionTourSpotlight);
    };

    const positionTourSpotlight = () => {
      if (!els.intro || els.intro.hidden || !els.tourSpotlight) return;
      const step = tourSteps[tourStep];
      let target = root.querySelector(step.target);
      if (step.target === ".gs-swipe__filter-console" && (!target || window.getComputedStyle(target).display === "none")) {
        target = root.querySelector("[data-gs-filter-overlay]");
      }
      if (!target) return;
      const rect = target.getBoundingClientRect();
      const pad = 10;
      const spotlightVars = {
        "--gs-spot-left": `${Math.max(8, rect.left - pad)}px`,
        "--gs-spot-top": `${Math.max(8, rect.top - pad)}px`,
        "--gs-spot-width": `${Math.min(window.innerWidth - 16, rect.width + pad * 2)}px`,
        "--gs-spot-height": `${Math.min(window.innerHeight - 16, rect.height + pad * 2)}px`
      };

      Object.entries(spotlightVars).forEach(([name, value]) => {
        els.intro.style.setProperty(name, value);
        els.tourSpotlight.style.setProperty(name, value);
      });
    };

    const openIntro = (source = "manual_guide_button") => {
      if (!els.intro) return;
      introReturnFocus = currentFocusAnchor();
      tourStep = 0;
      els.intro.hidden = false;
      setTourStep(0);
      trackSnackSwipe("snack_swipe_guide_opened", {
        ...baseTrackingParams(),
        guide_source: source
      });
      notifyPortalPanelState();
      focusFirstWithin(els.intro, els.tourNext);
    };

    const closeIntro = (reason = "skipped", options = {}) => {
      if (!els.intro) return;
      if (els.intro.hidden) return;
      els.intro.hidden = true;
      localStorage.setItem(introKey, "true");
      if (reason === "completed") {
        trackSnackSwipe("snack_swipe_guide_completed", baseTrackingParams());
      } else {
        trackSnackSwipe("snack_swipe_guide_skipped", {
          ...baseTrackingParams(),
          guide_step: tourStep + 1
        });
      }
      notifyPortalPanelState();
      restoreFocusTo(introReturnFocus, els.card, options);
      introReturnFocus = null;
    };

    const advanceTour = () => {
      startSession("guide_next");
      if (tourStep < tourSteps.length - 1) {
        setTourStep(tourStep + 1);
        return;
      }
      closeIntro("completed");
    };

    const maybeShowIntro = () => {
      if (!els.intro) return;
      if (localStorage.getItem(introKey) === "true") {
        els.intro.hidden = true;
        return;
      }
      openIntro("first_visit_auto");
    };

    const isFinePointer = () => {
      return Boolean(window.matchMedia?.("(hover: hover) and (pointer: fine)")?.matches);
    };

    const cardPromptText = () => {
      return "View Snack Intel";
    };

    const hasSeenFilterTip = () => {
      try {
        return sessionStorage.getItem(filterTipKey) === "true";
      } catch (error) {
        return false;
      }
    };

    const markFilterTipSeen = () => {
      try {
        sessionStorage.setItem(filterTipKey, "true");
      } catch (error) {
        // Some embedded browsers restrict storage; the tip is non-critical.
      }
    };

    const closeFilterTip = (reason = "dismissed", markSeen = true) => {
      if (filterTipTimer) {
        window.clearTimeout(filterTipTimer);
        filterTipTimer = null;
      }
      if (!els.filterTip || els.filterTip.hidden) {
        if (markSeen) markFilterTipSeen();
        return;
      }
      els.filterTip.hidden = true;
      root.classList.remove("is-filter-tip-open");
      if (markSeen) markFilterTipSeen();
      trackSnackSwipe("snack_swipe_filter_tip_dismissed", {
        ...baseTrackingParams(),
        dismiss_reason: reason
      });
    };

    const showFilterTip = () => {
      if (!els.filterTip || hasSeenFilterTip()) return;
      if ((els.filterOverlay && !els.filterOverlay.hidden) || (els.gestureDemo && !els.gestureDemo.hidden) || (els.intro && !els.intro.hidden)) return;
      els.filterTip.hidden = false;
      root.classList.add("is-filter-tip-open");
      trackSnackSwipe("snack_swipe_filter_tip_shown", baseTrackingParams());
    };

    const scheduleFilterTip = (delay = 900) => {
      if (!els.filterTip || hasSeenFilterTip() || !els.filterTip.hidden) return;
      if (filterTipTimer) window.clearTimeout(filterTipTimer);
      filterTipTimer = window.setTimeout(showFilterTip, delay);
    };

    const registerFilterTipEngagement = () => {
      if (!els.filterTip || hasSeenFilterTip() || !els.filterTip.hidden) return;
      if ((els.filterOverlay && !els.filterOverlay.hidden) || (els.gestureDemo && !els.gestureDemo.hidden) || (els.intro && !els.intro.hidden)) return;
      filterTipEngagementCount += 1;
      if (filterTipEngagementCount >= filterTipEngagementThreshold) scheduleFilterTip();
    };

    const easeGesture = (value) => {
      const clamped = Math.max(0, Math.min(1, value));
      return 1 - Math.pow(1 - clamped, 3);
    };

    const resetGestureDemoMotion = () => {
      if (gestureDemoMotionFrame) {
        window.cancelAnimationFrame(gestureDemoMotionFrame);
        gestureDemoMotionFrame = null;
      }
      gestureDemoMotionStart = 0;
      root.classList.remove("is-gesture-demo-phase-skip", "is-gesture-demo-phase-save");
      if (els.gestureDemoMotionCard) {
        els.gestureDemoMotionCard.style.removeProperty("animation");
        els.gestureDemoMotionCard.style.removeProperty("border-color");
        els.gestureDemoMotionCard.style.removeProperty("box-shadow");
        els.gestureDemoMotionCard.style.removeProperty("filter");
        els.gestureDemoMotionCard.style.removeProperty("opacity");
        els.gestureDemoMotionCard.style.removeProperty("transform");
      }
      [els.gestureDemoSkipToast, els.gestureDemoSaveToast].forEach((toast) => {
        if (!toast) return;
        toast.style.removeProperty("animation");
        toast.style.removeProperty("opacity");
        toast.style.removeProperty("transform");
      });
    };

    const startGestureDemoMotion = () => {
      if (!els.gestureDemoMotionCard || !els.gestureDemo || els.gestureDemo.hidden) return;
      resetGestureDemoMotion();
      const card = els.gestureDemoMotionCard;
      const center = { x: 0, y: 0, z: 0, r: 0, rx: 0, s: 0.98 };
      const left = { x: -165, y: -285, z: 130, r: -22, rx: 18, s: 0.84 };
      const right = { x: 165, y: -285, z: 130, r: 22, rx: 18, s: 0.84 };
      const mix = (from, to, amount) => {
        const eased = easeGesture(amount);
        return {
          x: from.x + (to.x - from.x) * eased,
          y: from.y + (to.y - from.y) * eased,
          z: from.z + (to.z - from.z) * eased,
          r: from.r + (to.r - from.r) * eased,
          rx: from.rx + (to.rx - from.rx) * eased,
          s: from.s + (to.s - from.s) * eased
        };
      };
      const paintCard = (pose, tone) => {
        const isSave = tone === "save";
        const isSkip = tone === "skip";
        const glow = isSave ? "100, 255, 106" : isSkip ? "255, 79, 112" : "184, 76, 255";
        const border = isSave ? "rgba(100, 255, 106, 1)" : isSkip ? "rgba(255, 79, 112, 1)" : "rgba(190, 82, 255, 0.92)";
        card.style.setProperty("animation", "none", "important");
        card.style.setProperty("border-color", border, "important");
        card.style.setProperty("box-shadow", [
          "0 36px 106px rgba(0, 0, 0, 0.72)",
          `0 0 ${isSave || isSkip ? 98 : 54}px rgba(${glow}, ${isSave || isSkip ? 0.9 : 0.52})`,
          "inset 0 1px 0 rgba(255, 255, 255, 0.14)"
        ].join(", "), "important");
        card.style.setProperty("filter", `brightness(${isSave || isSkip ? 1.12 : 1}) saturate(${isSave || isSkip ? 1.22 : 1.08})`, "important");
        card.style.setProperty("opacity", "1", "important");
        card.style.setProperty("transform", `perspective(1200px) translateX(-50%) translate3d(${pose.x}px, ${pose.y}px, ${pose.z}px) rotateX(${pose.rx}deg) rotateZ(${pose.r}deg) scale(${pose.s})`, "important");
        root.classList.toggle("is-gesture-demo-phase-skip", isSkip);
        root.classList.toggle("is-gesture-demo-phase-save", isSave);
      };
      const paintToast = (phase, amount) => {
        const skipActive = phase === "skip";
        const saveActive = phase === "save";
        const setToast = (toast, active) => {
          if (!toast) return;
          toast.style.setProperty("animation", "none", "important");
          toast.style.setProperty("opacity", active ? String(0.94 * amount) : "0", "important");
          toast.style.setProperty("transform", `translateX(-50%) translateY(${active ? 0 : 10}px) scale(${active ? 1 : 0.94})`, "important");
        };
        setToast(els.gestureDemoSkipToast, skipActive);
        setToast(els.gestureDemoSaveToast, saveActive);
      };
      const frame = (now) => {
        if (!gestureDemoMotionStart) gestureDemoMotionStart = now;
        if (!els.gestureDemo || els.gestureDemo.hidden) {
          resetGestureDemoMotion();
          return;
        }
        const cycle = 6200;
        const time = (now - gestureDemoMotionStart) % cycle;
        let pose = center;
        let tone = "center";
        let toastPhase = "";
        let toastAmount = 0;

        if (time < 650) {
          pose = center;
        } else if (time < 1250) {
          pose = mix(center, left, (time - 650) / 600);
          tone = "skip";
          toastPhase = "skip";
          toastAmount = (time - 650) / 600;
        } else if (time < 2350) {
          pose = left;
          tone = "skip";
          toastPhase = "skip";
          toastAmount = 1;
        } else if (time < 3050) {
          pose = mix(left, center, (time - 2350) / 700);
          tone = "skip";
          toastPhase = "skip";
          toastAmount = 1 - ((time - 2350) / 700);
        } else if (time < 3600) {
          pose = center;
        } else if (time < 4200) {
          pose = mix(center, right, (time - 3600) / 600);
          tone = "save";
          toastPhase = "save";
          toastAmount = (time - 3600) / 600;
        } else if (time < 5300) {
          pose = right;
          tone = "save";
          toastPhase = "save";
          toastAmount = 1;
        } else {
          pose = mix(right, center, (time - 5300) / 900);
          tone = "save";
          toastPhase = "save";
          toastAmount = 1 - ((time - 5300) / 900);
        }

        paintCard(pose, tone);
        paintToast(toastPhase, Math.max(0, Math.min(1, toastAmount)));
        gestureDemoMotionFrame = window.requestAnimationFrame(frame);
      };
      gestureDemoMotionFrame = window.requestAnimationFrame(frame);
    };

    const closeGestureDemo = (reason = "manual") => {
      if (!els.gestureDemo || els.gestureDemo.hidden) return;
      if (gestureDemoTimer) {
        window.clearTimeout(gestureDemoTimer);
        gestureDemoTimer = null;
      }
      resetGestureDemoMotion();
      els.gestureDemo.hidden = true;
      root.classList.remove("is-gesture-demo");
      localStorage.setItem(gestureIntroKey, "true");
      trackSnackSwipe("snack_swipe_gesture_intro_dismissed", {
        ...baseTrackingParams(),
        dismiss_reason: reason
      });
      notifyPortalPanelState();
      restoreFocusTo(gestureReturnFocus, els.card, {
        restoreFocus: !["guide_opened", "portal_replay", "overlay_close"].includes(reason)
      });
      gestureReturnFocus = null;
    };

    const openGestureDemo = () => {
      if (!els.gestureDemo || !currentProduct()) return;
      if (detailsOpen || (els.filterOverlay && !els.filterOverlay.hidden) || (els.list && !els.list.hidden) || (els.intro && !els.intro.hidden)) return;
      gestureReturnFocus = currentFocusAnchor();
      els.gestureDemo.hidden = false;
      root.classList.add("is-gesture-demo");
      trackSnackSwipe("snack_swipe_gesture_intro_shown", baseTrackingParams());
      notifyPortalPanelState();
      focusFirstWithin(els.gestureDemo, els.gestureDemoDismiss);
      startGestureDemoMotion();
    };

    const maybeShowGestureDemo = (options = {}) => {
      if (!els.gestureDemo) return;
      if (options.suppress) {
        els.gestureDemo.hidden = true;
        return;
      }
      if (!options.force && !root.dataset.localPreview && localStorage.getItem(gestureIntroKey) === "true") {
        els.gestureDemo.hidden = true;
        return;
      }
      window.setTimeout(openGestureDemo, 620);
    };

    const replayGestureDemo = () => {
      if (!els.gestureDemo) return;
      closeIntro("portal_replay", { restoreFocus: false });
      closeFilterOverlay({ restoreFocus: false });
      closeList({ restoreFocus: false });
      toggleDetails(false, { restoreFocus: false });
      window.setTimeout(openGestureDemo, 140);
    };

    const shapeClasses = [
      "is-ultra-wide-product",
      "is-wide-product",
      "is-tall-product",
      "is-ultra-tall-product"
    ];

    const resetCardMotion = () => {
      if (!els.card) return;
      els.card.classList.remove("is-like", "is-skip", "is-throwing", "is-lifted", "is-throw-source");
      els.card.style.transform = "";
      els.card.style.opacity = "";
      root.classList.remove("is-swipe-ack-save", "is-swipe-ack-skip");
      if (els.decisionFeedback) {
        els.decisionFeedback.className = "gs-swipe__decision-feedback";
        els.decisionFeedback.textContent = "";
      }
    };

    const updateImageShape = () => {
      if (!els.card || !els.image) return;
      els.card.classList.remove(...shapeClasses);
      if (!els.image.naturalWidth || !els.image.naturalHeight) return;
      const ratio = els.image.naturalWidth / els.image.naturalHeight;
      els.card.style.setProperty("--gs-product-ratio", ratio.toFixed(3));
      if (ratio > 2.7) {
        els.card.classList.add("is-ultra-wide-product");
      } else if (ratio > 1.45) {
        els.card.classList.add("is-wide-product");
      } else if (ratio < 0.5) {
        els.card.classList.add("is-ultra-tall-product");
      } else if (ratio < 0.78) {
        els.card.classList.add("is-tall-product");
      }
    };

    const updateProgress = () => {
      const total = products.length;
      const current = total ? Math.min(index + 1, total) : 0;
      const filterCount = activeFilters.length + activeCountries.length + activeSnackTypes.length + activeMissions.length;
      if (els.progressText) els.progressText.textContent = `${current} of ${total}`;
      if (els.progressBar) els.progressBar.style.width = total ? `${(current / total) * 100}%` : "0%";
      if (els.filterToggle) {
        els.filterToggle.dataset.gsFilterCount = String(filterCount);
        els.filterToggle.innerHTML = `${filterIconSvg("filters", "gs-swipe__filter-toggle-icon")}<span>Filters</span>${filterCount ? ` <b>${filterCount}</b>` : ""}`;
      }
    };

    const renderPreviewImage = (img, nameEl, product) => {
      if (!img) return;
      const image = productImageFor(product);
      if (!product || !image) {
        img.removeAttribute("src");
        img.alt = "";
        if (nameEl) nameEl.textContent = "";
        img.closest(".gs-swipe-card-stack__card")?.setAttribute("hidden", "");
        return;
      }
      img.closest(".gs-swipe-card-stack__card")?.removeAttribute("hidden");
      img.onerror = () => trackProductImageError(product, "deck_preview");
      img.src = image;
      img.alt = product.alt || product.title || "";
      if (nameEl) nameEl.textContent = displayTitleFor(product) || product.title || "";
    };

    const renderDeckStack = () => {
      renderPreviewImage(els.previewNext, els.previewNextName, products[index + 1]);
      renderPreviewImage(els.previewSecondary, els.previewSecondaryName, products[index + 2]);
      if (els.cardStack) els.cardStack.hidden = !products[index + 1];
    };

    const renderDetailsPanel = (product) => {
      if (!product) return;
      const country = countryFor(product);
      const snackClass = classFor(product);
      const visibleSnackClass = isUsefulMetaValue(snackClass) ? snackClass : "";
      const productPrice = priceFor(product);
      const review = reviewFor(product);
      const detailsReview = review && review.rating >= 4 ? review : null;
      const availability = availabilityFor(product);
      const unavailableProduct = !productIsPurchasable(product);
      const tasteTypeItems = tasteTypeItemsFor(product);
      const detailMissions = missionTrophyBadgesFor(product);
      const shortDescription = shortDescriptionFor(product);
      const detailTitle = snackIntelTitleFor(product);
      const detailsTitleBucket = intelTitleClassFor(detailTitle);
      const detailsTitleIsLong = detailsTitleBucket.className !== "is-title-standard";

      if (els.description) els.description.textContent = "";
      if (els.details) els.details.classList.toggle("has-long-details-title", detailsTitleIsLong);
      if (els.detailsTitle) {
        els.detailsTitle.textContent = detailTitle;
        applyTitleBucket(els.detailsTitle, detailsTitleBucket);
        if (detailsTitleBucket.className === "is-title-emergency") {
          flagPresentationIssue("intel_title_emergency", {
            product_id: product.id,
            handle: product.handle,
            title: detailTitle,
            length: detailsTitleBucket.length
          });
        }
      }
      if (els.detailsSummary) {
        els.detailsSummary.hidden = !shortDescription;
        els.detailsSummary.textContent = shortDescription;
      }
      if (els.detailsStatus) {
        const statusPieces = [];
        statusPieces.push(`
          <span class="gs-swipe-card__details-stock gs-swipe-card__details-stock--${escapeAttr(availability.status)}">
            <i aria-hidden="true"></i>${escapeHtml(availability.label)}
          </span>
        `);
        if (detailsReview) {
          statusPieces.push(`
            <span class="gs-swipe-card__details-rating">
              <b aria-hidden="true" style="--gs-review-fill: ${(detailsReview.rating / 5) * 100}%">★★★★★</b>
              <small>(${escapeHtml(detailsReview.count.toLocaleString())})</small>
            </span>
          `);
        }
        els.detailsStatus.innerHTML = statusPieces.join("");
      }
      if (els.detailsMetaStrip) {
        els.detailsMetaStrip.innerHTML = "";
        els.detailsMetaStrip.hidden = true;
      }
      if (els.detailsImage) {
        els.detailsImage.classList.remove("is-horizontal", "is-vertical", "is-square");
        const classifyDetailsImage = () => {
          const ratio = els.detailsImage.naturalWidth / Math.max(1, els.detailsImage.naturalHeight);
          els.detailsImage.classList.toggle("is-horizontal", ratio > 1.45);
          els.detailsImage.classList.toggle("is-vertical", ratio < 0.78);
          els.detailsImage.classList.toggle("is-square", ratio >= 0.78 && ratio <= 1.45);
        };
        els.detailsImage.onload = classifyDetailsImage;
        els.detailsImage.onerror = () => trackProductImageError(product, "detail");
        els.detailsImage.src = productImageFor(product);
        els.detailsImage.alt = product.alt || product.title || "";
        if (els.detailsImage.complete && els.detailsImage.naturalWidth) classifyDetailsImage();
      }
      if (els.detailsFacts) {
        const facts = [
          country ? {
            label: "Origin",
            value: countryDisplayName(country),
            icon: "",
            className: "origin",
            subValue: countryFlag(country)
          } : null,
          tasteTypeItems.length ? {
            label: "Taste + Type",
            value: "",
            icon: "",
            className: "taste-type",
            tasteItems: tasteTypeItems
          } : null
        ].filter(Boolean);
        els.detailsFacts.innerHTML = "";
        els.detailsFacts.dataset.gsFactCount = String(facts.length);
        facts.forEach((item) => {
          const fact = document.createElement("article");
          fact.className = `gs-swipe-card__details-fact gs-swipe-card__details-fact--${item.className}`;
          if (item.tasteItems) {
            fact.innerHTML = `
              <small>${escapeHtml(item.label)}</small>
              <div class="gs-swipe-card__details-taste-list">
                ${item.tasteItems.map((tasteItem) => `
                  <span class="gs-swipe-card__details-taste-chip gs-swipe-card__details-taste-chip--${escapeAttr(tasteItem.kind)}">
                    ${filterIconSvg(tasteItem.icon, "gs-swipe-card__details-taste-svg")}
                    <strong>${escapeHtml(cleanLabel(tasteItem.label))}</strong>
                  </span>
                `).join("")}
              </div>
            `;
          } else {
            fact.innerHTML = `
              <small>${escapeHtml(item.label)}</small>
              ${item.icon ? `<i class="gs-swipe-card__details-line-icon" aria-hidden="true">${item.icon}</i>` : ""}
              <strong>${escapeHtml(item.value)}</strong>
              ${item.subValue ? `<span>${escapeHtml(item.subValue)}</span>` : ""}
            `;
          }
          els.detailsFacts.appendChild(fact);
        });
      }
      if (els.detailsMissionRow) {
        els.detailsMissionRow.innerHTML = "";
        els.detailsMissionRow.dataset.gsMissionCount = String(detailMissions.length);
        detailMissions.forEach((mission) => {
          const missionCard = document.createElement("article");
          missionCard.className = `gs-swipe-card__details-mission gs-swipe-card__details-mission--${mission.tone}`;
          missionCard.innerHTML = `
            <i aria-hidden="true">${filterIconSvg(mission.iconName || mission.key, "gs-swipe-card__details-mission-svg")}</i>
            <span>
              <strong>${escapeHtml(mission.label)}</strong>
              <small>${escapeHtml(missionDescriptionFor(mission))}</small>
            </span>
          `;
          els.detailsMissionRow.appendChild(missionCard);
        });
      }
      if (els.detailsMissions) els.detailsMissions.hidden = !detailMissions.length;
      if (els.detailsNotes) els.detailsNotes.hidden = true;
      if (els.detailsLink) els.detailsLink.href = product.url || "#";
      if (els.detailsPrice) els.detailsPrice.textContent = unavailableProduct ? "" : productPrice || "";
      if (els.detailsAdd) {
        els.detailsAdd.disabled = unavailableProduct;
        els.detailsAdd.setAttribute("aria-disabled", unavailableProduct ? "true" : "false");
        els.detailsAdd.setAttribute("aria-label", unavailableProduct ? `${detailTitle} is unavailable` : `Add ${detailTitle} to cart`);
        const detailsAddLabel = els.detailsAdd.querySelector("strong");
        if (detailsAddLabel) detailsAddLabel.textContent = unavailableProduct ? "Unavailable" : "Add to Cart";
      }
    };

    const render = () => {
      const product = currentProduct();
      const badges = product ? merchBadgesFor(product) : [];
      const unavailableProduct = Boolean(product && !productIsPurchasable(product));
      detailsOpen = false;
      detailsProductOverride = null;
      document.documentElement.classList.remove("gs-swipe-details-lock");
      document.body?.classList.remove("gs-swipe-details-lock");
      root.classList.toggle("is-showing-unavailable", unavailableProduct);
      updateProgress();

      if (!product) {
        if (els.card) els.card.hidden = true;
        if (els.cardStack) els.cardStack.hidden = true;
        if (els.empty) {
          const hasFilters = activeFilters.length || activeCountries.length || activeSnackTypes.length || activeMissions.length;
          els.empty.hidden = false;
          els.empty.querySelector("h2").textContent = swipeDeckProducts.length
            ? (hasFilters ? "No snacks found in this galaxy" : "Swipe Complete")
            : "No Products Loaded";
          els.empty.querySelector("p").textContent = swipeDeckProducts.length
            ? (hasFilters ? "Try removing one filter or clear the route to keep exploring." : "Open your shortlist or reset filters to keep exploring.")
            : "Select a live Swipe collection with approved cutout images.";
          if (els.emptyActions) {
            els.emptyActions.innerHTML = "";
            if (hasFilters) {
              [
                activeCountries.length ? ["country", "Clear Countries"] : null,
                activeMissions.length ? ["mission", "Clear Missions"] : null,
                ["all", "Clear All"]
              ].filter(Boolean).forEach(([type, label]) => {
                const button = document.createElement("button");
                button.type = "button";
                button.textContent = label;
                button.addEventListener("click", () => removeActiveFilter(type));
                els.emptyActions.appendChild(button);
              });
            }
          }
        }
        setStatus(swipeDeckProducts.length ? "Deck complete" : "");
        if (swipeDeckProducts.length && !deckCompletedTracked) {
          deckCompletedTracked = true;
          trackSnackSwipe("snack_swipe_deck_completed", {
            ...baseTrackingParams(),
            ...selectedRouteParams(),
            saved_count: getSaved().length,
            saved_decision_count: savedDecisionCount,
            skipped_count: skippedCount,
            added_to_cart_count: addedToCartCount
          });
        }
        updateUndo();
        return;
      }

      if (els.card) {
        els.card.hidden = false;
        els.card.classList.toggle("is-unavailable-product", unavailableProduct);
        resetCardMotion();
      }
      renderDeckStack();
      if (els.empty) els.empty.hidden = true;
      if (els.image) {
        els.card?.classList.remove(...shapeClasses);
        els.image.onload = updateImageShape;
        els.image.onerror = () => trackProductImageError(product, "card");
        els.image.src = productImageFor(product);
        els.image.alt = product.alt || product.title || "";
        if (els.image.complete) updateImageShape();
      }
      if (els.gestureDemoImage) {
        els.gestureDemoImage.src = productImageFor(product);
        els.gestureDemoImage.alt = "";
      }
      if (els.gestureDemoProductName) {
        els.gestureDemoProductName.textContent = displayTitleFor(product) || product.title || "Snack Card";
      }
      const renderedTitle = displayTitleFor(product);
      const readableTitle = renderedTitle || product.title || "current snack";
      if (els.card) {
        els.card.setAttribute("aria-label", `Current snack card: ${readableTitle}`);
      }
      root.querySelector("[data-gs-details-toggle]")?.setAttribute("aria-label", `Open Snack Intel for ${readableTitle}`);
      if (els.title) {
        els.title.textContent = renderedTitle;
        const cardTitleBucket = swipeTitleClassFor(renderedTitle);
        applyTitleBucket(els.title, cardTitleBucket);
        if (cardTitleBucket.className === "is-title-emergency") {
          flagPresentationIssue("swipe_title_emergency", {
            product_id: product.id,
            handle: product.handle,
            title: renderedTitle,
            length: cardTitleBucket.length
          });
        }
      }
      if (els.productClass) els.productClass.textContent = `Class · ${classFor(product)}`;
      if (els.origin) {
        const country = countryFor(product);
        els.origin.textContent = country ? `Origin · ${country}` : "Origin · Add data";
      }
      const productPrice = priceFor(product);
      if (els.gestureDemoPrice) els.gestureDemoPrice.textContent = productPrice || "";
      if (els.price) els.price.textContent = productPrice;
      if (els.addPrice) els.addPrice.textContent = unavailableProduct ? "" : productPrice || "";
      if (els.addCurrent) {
        els.addCurrent.disabled = unavailableProduct;
        els.addCurrent.setAttribute("aria-disabled", unavailableProduct ? "true" : "false");
        els.addCurrent.setAttribute("aria-label", unavailableProduct ? `${readableTitle} is unavailable` : `Add ${readableTitle} to cart`);
        const addLabel = els.addCurrent.querySelector("small span");
        if (addLabel) addLabel.textContent = unavailableProduct ? "Unavailable" : "Add to Cart";
      }
      const country = countryFor(product);
      const review = reviewFor(product);
      const availability = availabilityFor(product);
      trackProductViewed(product);
      if (els.intel) {
        els.intel.innerHTML = "";
        els.intel.hidden = !country;
        if (country) {
          const span = document.createElement("span");
          span.className = "gs-swipe-card__country-row";
          span.textContent = `${countryFlag(country)} ${countryDisplayName(country)}`;
          els.intel.appendChild(span);
        }
      }
      if (els.meta) {
        const meta = [
          availability ? { label: availability.label, status: availability.status } : null
        ].filter(Boolean);
        els.meta.replaceChildren();
        meta.forEach((item, itemIndex) => {
          if (itemIndex) els.meta.appendChild(document.createTextNode(" · "));
          const span = document.createElement("span");
          span.textContent = item.label;
          if (item.status) span.className = `is-status is-status--${item.status}`;
          els.meta.appendChild(span);
        });
      }
      if (els.review) {
        els.review.hidden = !review;
        els.review.replaceChildren();
        if (review) {
          const stars = document.createElement("span");
          const score = document.createElement("span");
          stars.className = "gs-swipe-card__review-stars";
          stars.textContent = "★★★★★";
          stars.style.setProperty("--gs-review-fill", `${(review.rating / 5) * 100}%`);
          score.textContent = `(${review.count.toLocaleString()})`;
          els.review.append(stars, score);
        }
      }
      if (els.match) {
        const matches = [
          selectedButtonTexts("data-gs-filter", activeFilters),
          selectedButtonTexts("data-gs-country", activeCountries),
          selectedButtonTexts("data-gs-snack-type", activeSnackTypes),
          selectedButtonTexts("data-gs-mission", activeMissions)
        ].filter(Boolean);
        const hideCardRoute = root.classList.contains("is-portal-mode");
        els.match.hidden = hideCardRoute || !matches.length;
        els.match.textContent = !hideCardRoute && matches.length ? `Matched route: ${matches.join(" + ")}` : "";
      }
      if (els.cardPrompt) {
        if (unavailableProduct) {
          els.cardPrompt.textContent = "";
          els.cardPrompt.hidden = true;
        } else {
          els.cardPrompt.hidden = false;
          els.cardPrompt.textContent = cardPromptText();
        }
      }
      if (els.unavailableActions) {
        els.unavailableActions.hidden = !unavailableProduct;
      }
      if (els.priceNote) {
        els.priceNote.hidden = !isUnderFive(product);
        els.priceNote.textContent = isUnderFive(product) ? "Under $5" : "";
      }
      renderDetailsPanel(product);
      if (els.details) els.details.hidden = true;
      detailsOpen = false;
      els.productLinks.forEach((link) => {
        link.href = product.url || "#";
        link.setAttribute("aria-label", `View Snack Intel for ${readableTitle}`);
      });
      if (els.merchBadges) {
        els.merchBadges.innerHTML = "";
        badges.forEach((badge) => {
          const span = document.createElement("span");
          span.className = `gs-swipe-card__badge gs-swipe-card__badge--${badge.tone}`;
          span.textContent = badge.label;
          if (badge.icon) span.dataset.icon = badge.icon;
          els.merchBadges.appendChild(span);
        });
      }
      setStatus("Use buttons, keyboard arrows, or swipe");
      updateUndo();
    };

    const saveProduct = (product) => {
      const saved = getSaved();
      if (!saved.some((item) => String(item.variantId) === String(product.variantId))) {
        saved.push(product);
        setSaved(saved);
        return true;
      }
      return false;
    };

    const showDecisionFeedback = (type) => {
      const isSave = type === "like";
      root.classList.remove("is-swipe-ack-save", "is-swipe-ack-skip");
      if (els.decisionFeedback) {
        els.decisionFeedback.className = "gs-swipe__decision-feedback";
        els.decisionFeedback.textContent = isSave ? "Saved to list" : "Skipped";
      }
      // Restart CSS animations even when the same action fires twice in a row.
      void root.offsetWidth;
      root.classList.add(isSave ? "is-swipe-ack-save" : "is-swipe-ack-skip");
      if (els.decisionFeedback) {
        els.decisionFeedback.classList.add(isSave ? "is-save" : "is-skip", "is-active");
      }
    };

    const animateDecision = (type, callback) => {
      if (!els.card) {
        callback();
        return;
      }
      isAnimating = true;
      if (els.reaction) els.reaction.textContent = type === "like" ? "Save!" : "Skip";
      showDecisionFeedback(type);
      els.card.classList.add(type === "like" ? "is-like" : "is-skip", "is-throwing");
      const prefersReducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
      const rect = els.card.getBoundingClientRect();
      const clone = prefersReducedMotion ? null : els.card.cloneNode(true);
      let didFinish = false;

      const finish = () => {
        if (didFinish) return;
        didFinish = true;
        clone?.remove();
        try {
          resetCardMotion();
          callback();
        } finally {
          isAnimating = false;
        }
      };

      if (!clone || !rect.width || !rect.height) {
        window.setTimeout(finish, 120);
        return;
      }

      clone.classList.add(
        "gs-swipe-card--throw-clone",
        type === "like" ? "is-throwing-right" : "is-throwing-left"
      );
      clone.setAttribute("aria-hidden", "true");
      clone.removeAttribute("tabindex");
      clone.removeAttribute("data-gs-card");
      if ("inert" in clone) clone.inert = true;
      clone.style.left = `${rect.left}px`;
      clone.style.top = `${rect.top}px`;
      clone.style.width = `${rect.width}px`;
      clone.style.height = `${rect.height}px`;
      clone.style.transform = "none";
      clone.style.opacity = "";
      els.card.classList.add("is-throw-source");
      root.appendChild(clone);
      clone.addEventListener("animationend", finish, { once: true });
      window.setTimeout(finish, 720);
    };

    const decide = (type, inputType = "unknown") => {
      if (isAnimating) return;
      const product = currentProduct();
      if (!product) return;
      if (!productIsPurchasable(product)) {
        showAvailableDeck();
        return;
      }
      startSession(type === "like" ? "save" : "skip");
      if (launchProductMatches(product)) {
        launchProductPending = false;
        launchIntelPending = false;
      }
      markProductsSwipedForSession([product]);
      const normalizedInputType = inputTypeCounts[inputType] !== undefined ? inputType : "unknown";
      inputTypeCounts[normalizedInputType] += 1;
      cardActionCount += 1;
      let addedToShortlist = false;
      if (type === "like") {
        addedToShortlist = saveProduct(product);
        setStatus(addedToShortlist ? `${product.title} added to your shortlist` : `${product.title} is already on your shortlist`);
        savedDecisionCount += 1;
        trackSnackSwipe("snack_swipe_decision", {
          ...productTrackingParams(product),
          action: "save",
          input_type: normalizedInputType,
          saved_count: getSaved().length,
          deck_remaining_count: Math.max(0, products.length - index - 1),
          filter_state: selectedRouteParams().filter_combo_key
        });
      } else {
        setStatus(`${product.title} skipped`);
        skippedCount += 1;
        trackSnackSwipe("snack_swipe_decision", {
          ...productTrackingParams(product),
          action: "skip",
          input_type: normalizedInputType,
          saved_count: getSaved().length,
          deck_remaining_count: Math.max(0, products.length - index - 1),
          filter_state: selectedRouteParams().filter_combo_key
        });
      }
      lastSwipe = { product, index, type, addedToShortlist };
      updateUndo();
      animateDecision(type, () => {
        index += 1;
        render();
        registerFilterTipEngagement();
      });
    };

    const undoLastSwipe = () => {
      if (!lastSwipe || isAnimating) return;
      if (lastSwipe.addedToShortlist) {
        removeSaved(lastSwipe.product.variantId);
      }
      unmarkProductsSwipedForSession([lastSwipe.product]);
      index = Math.max(0, lastSwipe.index);
      setStatus(`Brought back ${lastSwipe.product.title}`);
      lastSwipe = null;
      render();
    };

    const toggleDetails = (forceOpen, options = {}) => {
      const targetProduct = detailProduct();
      if (!els.details || !targetProduct) return;
      const wasOpen = detailsOpen;
      detailsOpen = typeof forceOpen === "boolean" ? forceOpen : !detailsOpen;
      if (!wasOpen && detailsOpen) {
        detailsReturnFocus = options.returnFocus || currentFocusAnchor();
      }
      els.details.hidden = !detailsOpen;
      document.documentElement.classList.toggle("gs-swipe-details-lock", detailsOpen);
      document.body?.classList.toggle("gs-swipe-details-lock", detailsOpen);
      if (detailsOpen) {
        startSession("snack_intel");
        detailOpenCount += 1;
        renderDetailsPanel(targetProduct);
        trackSnackSwipe("snack_swipe_snack_intel_open", productTrackingParams(targetProduct));
        focusFirstWithin(els.details, els.detailsClose);
      } else {
        detailsProductOverride = null;
        if (wasOpen) {
          restoreFocusTo(detailsReturnFocus, els.card, options);
          detailsReturnFocus = null;
        }
      }
      setStatus(detailsOpen ? "Product details shown" : "Product details hidden");
      notifyPortalPanelState();
    };

    const savedItemKey = (item) => normalize(item?.variantId || item?.id || item?.handle || item?.title);

    const savedItemAvailable = (item) => item && productIsPurchasable(item);

    const markProductsAddedToCartForSession = (items, options = {}) => {
      const keys = items.map(productSessionKey).filter(Boolean);
      if (!keys.length) return;
      keys.forEach((key) => addedToCartProductKeys.add(key));
      writeSessionProductKeys(addedToCartSessionKey, addedToCartProductKeys);
      if (options.refreshDeck === false) return;

      const currentKey = productSessionKey(currentProduct());
      const detailKey = productSessionKey(detailProduct());
      if (detailKey && keys.includes(detailKey)) {
        toggleDetails(false);
      }
      products = products.filter((product) => !isProductExcludedForSession(product));
      if (currentKey && keys.includes(currentKey)) {
        index = Math.min(index, Math.max(0, products.length - 1));
      } else {
        index = Math.min(index, Math.max(0, products.length - 1));
      }
      render();
    };

    const savedQuantityFor = (item) => {
      const key = savedItemKey(item);
      return Math.max(1, Number(savedListQuantities[key] || 1));
    };

    const setSavedQuantity = (item, quantity) => {
      const key = savedItemKey(item);
      savedListQuantities[key] = Math.max(1, Number(quantity || 1));
      renderShortlist();
    };

    const syncSavedListState = (saved, options = {}) => {
      const keys = new Set(saved.map(savedItemKey));
      const availableKeys = new Set(saved.filter(savedItemAvailable).map(savedItemKey));
      savedListSelectedIds = new Set([...savedListSelectedIds].filter((key) => keys.has(key) && availableKeys.has(key)));
      savedListAddedIds = new Set([...savedListAddedIds].filter((key) => keys.has(key)));
      savedListAddingIds = new Set([...savedListAddingIds].filter((key) => keys.has(key)));
      Object.keys(savedListQuantities).forEach((key) => {
        if (!keys.has(key)) delete savedListQuantities[key];
      });
      saved.forEach((item) => {
        const key = savedItemKey(item);
        if (!savedListQuantities[key]) savedListQuantities[key] = 1;
        if (options.selectAll && savedItemAvailable(item)) savedListSelectedIds.add(key);
      });
    };

    const setSavedListToast = (message, actionLabel, actionHandler) => {
      if (savedListToastTimer) {
        window.clearTimeout(savedListToastTimer);
        savedListToastTimer = null;
      }
      if (!els.listToast) return;
      els.listToast.hidden = false;
      els.listToast.innerHTML = "";
      const text = document.createElement("span");
      text.textContent = message;
      els.listToast.appendChild(text);
      if (actionLabel && actionHandler) {
        const button = document.createElement("button");
        button.type = "button";
        button.textContent = actionLabel;
        button.addEventListener("click", actionHandler);
        els.listToast.appendChild(button);
      }
      savedListToastTimer = window.setTimeout(() => {
        if (els.listToast) els.listToast.hidden = true;
      }, 4200);
    };

    const removeSaved = (variantId) => {
      const saved = getSaved();
      const removedIndex = saved.findIndex((item) => String(item.variantId) === String(variantId));
      const removedItem = saved[removedIndex];
      if (!removedItem) return;
      const key = savedItemKey(removedItem);
      lastRemovedSaved = { item: removedItem, index: removedIndex };
      savedListSelectedIds.delete(key);
      savedListAddedIds.delete(key);
      savedListAddingIds.delete(key);
      delete savedListQuantities[key];
      setSaved(saved.filter((item) => String(item.variantId) !== String(variantId)));
      setSavedListToast(`${displayTitleFor(removedItem) || removedItem.title || "Snack"} removed`, "Undo", () => {
        if (!lastRemovedSaved) return;
        const currentSaved = getSaved();
        if (currentSaved.some((item) => String(item.variantId) === String(lastRemovedSaved.item.variantId))) return;
        currentSaved.splice(Math.min(lastRemovedSaved.index, currentSaved.length), 0, lastRemovedSaved.item);
        setSaved(currentSaved);
        savedListSelectedIds.add(savedItemKey(lastRemovedSaved.item));
        renderShortlist();
        if (els.listToast) els.listToast.hidden = true;
        lastRemovedSaved = null;
      });
    };

    const openSavedItemDetails = (item, opener = currentFocusAnchor()) => {
      if (!item) return;
      detailsProductOverride = item;
      renderDetailsPanel(item);
      toggleDetails(true, { returnFocus: opener });
      trackSnackSwipe("snack_swipe_snack_intel_open", {
        ...productTrackingParams(item),
        saved_count: getSaved().length
      });
    };

    const savedListTotals = (saved) => {
      const selected = saved.filter((item) => savedListSelectedIds.has(savedItemKey(item)) && savedItemAvailable(item));
      const quantity = selected.reduce((sum, item) => sum + savedQuantityFor(item), 0);
      const total = selected.reduce((sum, item) => sum + Number(item.priceCents || 0) * savedQuantityFor(item), 0);
      return { selected, quantity, total };
    };

    const renderSavedItemCard = (item) => {
      const key = savedItemKey(item);
      const title = displayTitleFor(item) || item.title || "Saved snack";
      const country = countryFor(item);
      const availability = availabilityFor(item);
      const review = reviewFor(item);
      const price = priceFor(item);
      const quantity = savedQuantityFor(item);
      const selected = savedListSelectedIds.has(key);
      const adding = savedListAddingIds.has(key);
      const added = savedListAddedIds.has(key);
      const available = savedItemAvailable(item);
      const row = document.createElement("article");
      row.className = [
        "gs-swipe-list__item",
        selected ? "is-selected" : "",
        available ? "" : "is-unavailable",
        added ? "is-added" : "",
        adding ? "is-adding" : ""
      ].filter(Boolean).join(" ");
      row.tabIndex = 0;
      row.dataset.savedKey = key;
      row.setAttribute("role", "button");
      row.setAttribute("aria-label", `View Snack Intel for ${title}`);
      row.innerHTML = `
        <div class="gs-swipe-list__stage" data-gs-saved-intel>
          <button class="gs-swipe-list__check" type="button" data-gs-saved-select aria-pressed="${selected ? "true" : "false"}" aria-label="${selected ? "Unselect" : "Select"} ${escapeAttr(title)} for bulk add" ${available ? "" : "disabled"}>
            <span aria-hidden="true">${selected ? "✓" : ""}</span>
          </button>
          <img src="${escapeAttr(item.image || "")}" alt="${escapeAttr(title)}">
        </div>
        <div class="gs-swipe-list__info" data-gs-saved-intel>
          <h3>${escapeHtml(title)} <span class="gs-swipe-list__intel-icon" aria-hidden="true">▤</span></h3>
          ${country ? `<p class="gs-swipe-list__meta"><span>${escapeHtml(countryFlag(country))} ${escapeHtml(country)}</span></p>` : ""}
          <p class="gs-swipe-list__stock gs-swipe-list__stock--${escapeAttr(availability.status)}"><span></span>${escapeHtml(availability.label)}</p>
          ${review ? `<p class="gs-swipe-list__review"><span style="--gs-review-fill:${(review.rating / 5) * 100}%">★★★★★</span><b>${review.rating.toFixed(1)} (${review.count.toLocaleString()})</b></p>` : ""}
        </div>
        <div class="gs-swipe-list__buy">
          <button class="gs-swipe-list__remove" type="button" data-gs-saved-remove aria-label="Remove ${escapeAttr(title)} from Snack List">×</button>
          <strong>${escapeHtml(price)}</strong>
          <div class="gs-swipe-list__qty" aria-label="Quantity">
            <button type="button" data-gs-saved-qty-minus aria-label="Decrease ${escapeAttr(title)} quantity" ${quantity <= 1 ? "disabled" : ""}>−</button>
            <span>${quantity}</span>
            <button type="button" data-gs-saved-qty-plus aria-label="Increase ${escapeAttr(title)} quantity">+</button>
          </div>
          <button class="gs-swipe-list__add" type="button" data-gs-saved-add aria-label="Add ${escapeAttr(title)} to cart" ${available && !adding ? "" : "disabled"}>
            ${adding ? "Adding..." : (added ? "Added" : "Add")}
          </button>
        </div>
      `;

      row.addEventListener("click", (event) => {
        if (event.target.closest("button, a, input")) return;
        openSavedItemDetails(item, row);
      });
      row.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        if (event.target.closest("button, a, input")) return;
        event.preventDefault();
        openSavedItemDetails(item, row);
      });
      row.querySelectorAll("[data-gs-saved-intel]").forEach((zone) => {
        zone.addEventListener("click", (event) => {
          if (event.target.closest("button, a, input")) return;
          event.stopPropagation();
          openSavedItemDetails(item, row);
        });
      });
      row.querySelector(".gs-swipe-list__buy")?.addEventListener("click", (event) => {
        event.stopPropagation();
      });
      row.querySelector("[data-gs-saved-select]")?.addEventListener("click", (event) => {
        event.stopPropagation();
        if (!available) return;
        if (savedListSelectedIds.has(key)) savedListSelectedIds.delete(key);
        else savedListSelectedIds.add(key);
        renderShortlist();
      });
      row.querySelector("[data-gs-saved-remove]")?.addEventListener("click", (event) => {
        event.stopPropagation();
        removeSaved(item.variantId);
      });
      row.querySelector("[data-gs-saved-qty-minus]")?.addEventListener("click", (event) => {
        event.stopPropagation();
        setSavedQuantity(item, quantity - 1);
      });
      row.querySelector("[data-gs-saved-qty-plus]")?.addEventListener("click", (event) => {
        event.stopPropagation();
        setSavedQuantity(item, quantity + 1);
      });
      row.querySelector("[data-gs-saved-add]")?.addEventListener("click", (event) => {
        event.stopPropagation();
        addSavedItemToCart(item);
      });
      return row;
    };

    const renderShortlist = () => {
      const saved = getSaved();
      syncSavedListState(saved);
      const totals = savedListTotals(saved);
      els.counts.forEach((count) => {
        count.textContent = saved.length;
      });
      if (els.shortlistTotal) {
        els.shortlistTotal.textContent = money(totals.total);
      }
      if (els.listCta) {
        if (!totals.selected.length) {
          els.listCta.textContent = "Select snacks to add";
        } else if (totals.selected.length === saved.filter(savedItemAvailable).length) {
          els.listCta.textContent = "Add all to cart";
        } else {
          els.listCta.textContent = `Add ${totals.quantity} to cart`;
        }
      }
      const bulkButton = root.querySelector("[data-gs-add-all]");
      if (bulkButton) {
        bulkButton.disabled = !totals.selected.length;
        bulkButton.classList.toggle("is-disabled", !totals.selected.length);
      }
      if (els.listFooter) {
        els.listFooter.hidden = !saved.length;
      }
      if (!els.listItems) return;
      els.listItems.innerHTML = "";
      if (!saved.length) {
        const empty = document.createElement("div");
        empty.className = "gs-swipe-list__empty";
        empty.innerHTML = `
          <span aria-hidden="true">✦</span>
          <h3>Your Snack List is empty</h3>
          <p>Swipe right on snacks you want to remember.</p>
          <button type="button" data-gs-close-list>Back to Swipe</button>
        `;
        empty.querySelector("[data-gs-close-list]")?.addEventListener("click", closeList);
        els.listItems.appendChild(empty);
        return;
      }
      saved.forEach((item) => {
        els.listItems.appendChild(renderSavedItemCard(item));
      });
    };

    const openList = () => {
      listReturnFocus = currentFocusAnchor();
      startSession("saved_list");
      savedListOpened = true;
      savedListOpenCount += 1;
      syncSavedListState(getSaved(), { selectAll: true });
      renderShortlist();
      if (els.list) {
        els.list.hidden = false;
        previousBodyOverflow = document.body.style.overflow;
        previousDocumentOverflow = document.documentElement.style.overflow;
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
        focusFirstWithin(els.list, els.list.querySelector("[data-gs-close-list]"));
      }
      notifyPortalPanelState();
      trackSnackSwipe("snack_swipe_saved_list_open", {
        ...baseTrackingParams(),
        saved_count: getSaved().length
      });
    };

    const closeList = (options = {}) => {
      if (els.list) els.list.hidden = true;
      if (els.listToast) els.listToast.hidden = true;
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousDocumentOverflow;
      notifyPortalPanelState();
      restoreFocusTo(listReturnFocus, root.querySelector("[data-gs-open-list]") || els.card, options);
      listReturnFocus = null;
    };

    const resetFilterSectionRows = () => {
      if (!els.filterOverlay) return;
      els.filterOverlay.querySelectorAll("[data-gs-filter-section]").forEach((section) => {
        section.classList.remove("is-expanded");
        const toggle = section.querySelector("[data-gs-filter-section-toggle]");
        toggle?.setAttribute("aria-expanded", "false");
      });
    };

    const openFilterOverlay = () => {
      if (!els.filterOverlay || !els.filterToggle) return;
      filterReturnFocus = currentFocusAnchor(els.filterToggle);
      startSession("filters");
      closeFilterTip("filters_opened");
      syncDraftFilters();
      updateFilterButtonStates();
      resetFilterSectionRows();
      els.filterOverlay.hidden = false;
      els.filterToggle.setAttribute("aria-expanded", "true");
      els.filterToggle.classList.add("is-open");
      root.classList.add("is-filter-open");
      filtersOpenCount += 1;
      previousBodyOverflow = document.body.style.overflow;
      previousDocumentOverflow = document.documentElement.style.overflow;
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      focusFirstWithin(els.filterOverlay, els.filterOverlay.querySelector("button[data-gs-close-filters], [data-gs-apply-filters]"));
      trackSnackSwipe("snack_swipe_filters_opened", {
        ...baseTrackingParams(),
        ...selectedRouteParams()
      });
      notifyPortalPanelState();
    };

    const closeFilterOverlay = (options = {}) => {
      if (!els.filterOverlay || !els.filterToggle) return;
      const wasOpen = !els.filterOverlay.hidden;
      els.filterOverlay.hidden = true;
      els.filterToggle.setAttribute("aria-expanded", "false");
      els.filterToggle.classList.remove("is-open");
      root.classList.remove("is-filter-open");
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousDocumentOverflow;
      notifyPortalPanelState();
      if (wasOpen) {
        restoreFocusTo(filterReturnFocus, els.filterToggle, options);
        filterReturnFocus = null;
      }
    };

    const refreshCartState = (payload = {}) => {
      debugLog("cart refresh", payload);
      if (isPortalMode) {
        notifyPortalCartUpdated(payload);
        return;
      }
      document.dispatchEvent(new CustomEvent("cart:refresh", { detail: payload }));
      document.dispatchEvent(new CustomEvent("rebuy:cart.change", { detail: payload }));
    };

    const openCartDrawerOrFallback = (payload = {}) => {
      debugLog("open cart drawer", payload);
      if (isPortalMode) return;
      if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === "function") {
        window.Rebuy.SmartCart.show();
      } else {
        window.location.href = "/cart";
      }
    };

    const attributeNumber = (value) => {
      const parsed = Number(value || 0);
      return Number.isFinite(parsed) ? parsed : 0;
    };

    const boundedAttributeList = (value, maxItems = 96, maxLength = 3000) => {
      const values = normalize(value)
        .split("|")
        .map(normalize)
        .filter(Boolean);
      const uniqueValues = Array.from(new Set(values));
      while (uniqueValues.length > maxItems) uniqueValues.shift();
      while (uniqueValues.join("|").length > maxLength && uniqueValues.length > 1) uniqueValues.shift();
      return uniqueValues.join("|");
    };

    const appendAttributeValue = (existingValue, newValue) => {
      return boundedAttributeList(`${existingValue || ""}|${newValue || ""}`);
    };

    const appendAttributeValues = (existingValue, newValues = []) => {
      const values = Array.isArray(newValues) ? newValues : [newValues];
      return values.reduce((currentValue, value) => appendAttributeValue(currentValue, value), existingValue || "");
    };

    const cartAttributeToken = (value, fallback = "") => {
      const token = normalize(value || fallback)
        .replace(/[|:]/g, "-")
        .replace(/\s+/g, "-")
        .slice(0, 96);
      return token || normalize(fallback);
    };

    const cartAttributeProductHandle = (product) => cartAttributeToken(
      product?.handle || product?.productHandle || normalizeSlug(displayTitleFor(product) || product?.title),
      product?.variantId || product?.id || "unknown_product"
    );

    const cartAttributeVariantId = (product) => cartAttributeToken(
      product?.variantId || product?.variant_id || product?.id,
      cartAttributeProductHandle(product)
    );

    const cartAttributeSourceEntry = (product, source, priorSwipeAction) => {
      const handle = cartAttributeProductHandle(product);
      if (!handle) return "";
      return [
        handle,
        cartAttributeToken(source, "unknown"),
        cartAttributeToken(priorSwipeAction, "none")
      ].join(":");
    };

    const markCartForSnackSwipe = async (details = {}) => {
      if (isDemoMode()) return false;

      const now = new Date().toISOString();
      const quantity = Math.max(1, Number(details.quantity || details.item_count || details.itemCount || 1));
      const source = normalize(details.source || "unknown");
      const priorSwipeAction = normalize(details.prior_swipe_action || details.priorSwipeAction || (source.startsWith("saved") ? "saved" : "none")) || "none";
      const products = (Array.isArray(details.products) ? details.products : [details.product])
        .filter(Boolean);

      try {
        const cartResponse = await fetch("/cart.js", {
          headers: { Accept: "application/json" }
        });
        const cart = cartResponse.ok ? await cartResponse.json() : {};
        const existingAttributes = cart && typeof cart.attributes === "object" && cart.attributes
          ? cart.attributes
          : {};
        const keys = SNACK_SWIPE_CART_ATTRIBUTE_KEYS;
        const attributes = {
          ...existingAttributes,
          [keys.used]: "Yes",
          [keys.sessionId]: existingAttributes[keys.sessionId] || getSessionId(),
          [keys.firstAddedAt]: existingAttributes[keys.firstAddedAt] || now,
          [keys.lastAddedAt]: now,
          [keys.sources]: appendAttributeValue(existingAttributes[keys.sources], source),
          [keys.addActions]: String(attributeNumber(existingAttributes[keys.addActions]) + 1),
          [keys.itemsAdded]: String(attributeNumber(existingAttributes[keys.itemsAdded]) + quantity),
          [keys.version]: root.dataset.swipeVersion || SNACK_SWIPE_ANALYTICS_VERSION
        };
        if (products.length) {
          const productHandles = products.map(cartAttributeProductHandle).filter(Boolean);
          const variantIds = products.map(cartAttributeVariantId).filter(Boolean);
          const productSources = products.map((product) => cartAttributeSourceEntry(product, source, priorSwipeAction)).filter(Boolean);

          attributes[keys.productHandles] = appendAttributeValues(existingAttributes[keys.productHandles], productHandles);
          attributes[keys.variantIds] = appendAttributeValues(existingAttributes[keys.variantIds], variantIds);
          attributes[keys.productSources] = appendAttributeValues(existingAttributes[keys.productSources], productSources);
          if (priorSwipeAction === "saved" || source.startsWith("saved")) {
            attributes[keys.savedProductHandles] = appendAttributeValues(existingAttributes[keys.savedProductHandles], productHandles);
          }
        }

        const updateResponse = await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ attributes })
        });
        if (!updateResponse.ok) throw new Error("Cart attribute update failed");
        debugLog("cart attributes marked", {
          source,
          quantity,
          product_count: products.length,
          session_id: attributes[keys.sessionId]
        });
        return true;
      } catch (error) {
        console.warn("Snack Swipe could not mark cart attributes", error);
        return false;
      }
    };

    const handleCurrentCartSuccess = async (product, cartSource, trackingParams, options = {}) => {
      const value = Number(product.priceCents || 0) / 100;
      const priorSwipeAction = savedListContainsProduct(product) ? "saved" : "none";
      const cartPayload = {
        source: cartSource,
        item_count: 1,
        quantity: 1,
        value
      };

      localCartCount += 1;
      updateCartCount();
      addedToCartCount += 1;
      addToCartSuccessCount += 1;
      addToCartSuccessQuantity += 1;
      markProductsAddedToCartForSession([product]);

      if (!isDemoMode()) {
        trackSnackSwipe("add_to_cart", {
          ...baseTrackingParams(),
          currency: "USD",
          value,
          items: [{
            item_id: product.variantId || product.id,
            item_name: displayTitleFor(product) || product.title,
            item_category: product.productType || classFor(product),
            price: value,
            quantity: 1
          }]
        });
      }

      trackSnackSwipe("snack_swipe_add_to_cart_result", {
        ...trackingParams,
        result: "success",
        source: cartSource,
        cart_source: cartSource,
        prior_swipe_action: priorSwipeAction,
        quantity: 1,
        item_count: 1,
        rebuy_drawer_opened: options.openCart !== false,
        value
      });
      trackProductAddedToCart(product, {
        source: cartSource,
        quantity: 1,
        prior_swipe_action: priorSwipeAction,
        saved_count: getSaved().length,
        rebuy_drawer_opened: options.openCart !== false
      });
      await markCartForSnackSwipe({
        source: cartSource,
        item_count: 1,
        quantity: 1,
        products: [product],
        prior_swipe_action: priorSwipeAction
      });
      refreshCartState(cartPayload);
      setStatus(`${product.title} added to cart`);
      if (options.openCart !== false) openCartDrawerOrFallback(cartPayload);
    };

    const addSavedItemsToCart = async (itemsToAdd, options = {}) => {
      const cleanItems = itemsToAdd.filter((item) => item && item.variantId && savedItemAvailable(item));
      const quantity = cleanItems.reduce((sum, item) => sum + savedQuantityFor(item), 0);
      const estimatedValue = cleanItems.reduce((sum, item) => sum + Number(item.priceCents || 0) * savedQuantityFor(item), 0) / 100;
      const keysToClear = new Set(cleanItems.map(savedItemKey));
      if (!cleanItems.length || !quantity) return false;

      const cartPayload = {
        source: options.source === "bulk" ? "saved_bulk" : "saved_item",
        item_count: cleanItems.length,
        quantity,
        estimated_value: estimatedValue
      };
      const singleSavedItem = cleanItems.length === 1 ? cleanItems[0] : null;
      const savedCartTrackingParams = singleSavedItem
        ? productTrackingParams(singleSavedItem)
        : {
          ...baseTrackingParams(),
          ...selectedRouteParams()
        };
      addToCartClickCount += 1;
      trackSnackSwipe("snack_swipe_add_to_cart_click", {
        ...savedCartTrackingParams,
        source: cartPayload.source,
        cart_source: cartPayload.source,
        prior_swipe_action: singleSavedItem ? "saved" : "none",
        item_count: cleanItems.length,
        quantity,
        value: estimatedValue,
        estimated_value: estimatedValue,
        saved_count: getSaved().length
      });

      const handleSavedCartSuccess = async () => {
        localCartCount += quantity;
        updateCartCount();
        addedToCartCount += quantity;
        addToCartSuccessCount += 1;
        addToCartSuccessQuantity += quantity;
        markProductsAddedToCartForSession(cleanItems);
        trackSnackSwipe("snack_swipe_add_to_cart_result", {
          ...savedCartTrackingParams,
          result: "success",
          source: cartPayload.source,
          cart_source: cartPayload.source,
          prior_swipe_action: singleSavedItem ? "saved" : "none",
          saved_count: getSaved().length,
          item_count: cleanItems.length,
          quantity,
          value: estimatedValue,
          rebuy_drawer_opened: Boolean(options.openCart),
          estimated_value: estimatedValue
        });
        cleanItems.forEach((item) => {
          trackProductAddedToCart(item, {
            source: cartPayload.source,
            quantity: savedQuantityFor(item),
            prior_swipe_action: "saved",
            saved_count: getSaved().length,
            rebuy_drawer_opened: Boolean(options.openCart)
          });
        });
        await markCartForSnackSwipe({
          source: cartPayload.source,
          item_count: cleanItems.length,
          quantity,
          products: cleanItems,
          prior_swipe_action: "saved"
        });
        if (options.clearOnSuccess) {
          setSaved(getSaved().filter((item) => !keysToClear.has(savedItemKey(item))));
        }
        refreshCartState(cartPayload);
        setStatus(`${quantity} saved snack${quantity === 1 ? "" : "s"} added to cart${options.clearOnSuccess ? " and cleared" : ""}`);
        if (options.openCart) openCartDrawerOrFallback(cartPayload);
      };

      if (isDemoMode()) {
        await handleSavedCartSuccess();
        setStatus(`Local test: ${quantity} saved snack${quantity === 1 ? "" : "s"} added to test cart${options.clearOnSuccess ? " and cleared" : ""}`);
        return true;
      }

      const cartItems = cleanItems.map((item) => ({
        id: Number(item.variantId),
        quantity: savedQuantityFor(item)
      }));
      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: cartItems })
        });
        if (!response.ok) throw new Error("Cart add failed");
        await handleSavedCartSuccess();
        return true;
      } catch (error) {
        console.warn(error);
        setStatus("Could not add saved snacks to cart");
        trackSnackSwipe("snack_swipe_add_to_cart_result", {
          ...savedCartTrackingParams,
          result: "failure",
          source: cartPayload.source,
          cart_source: cartPayload.source,
          prior_swipe_action: singleSavedItem ? "saved" : "none",
          item_count: cleanItems.length,
          quantity,
          value: estimatedValue,
          estimated_value: estimatedValue,
          error_code: "cart_add_failed",
          error_message_safe: safeErrorMessage(error)
        });
        trackSnackSwipe("snack_swipe_error", {
          ...baseTrackingParams(),
          ...selectedRouteParams(),
          error_area: "saved_cart_add",
          error_code: "cart_add_failed",
          error_message_safe: safeErrorMessage(error)
        });
        return false;
      }
    };

    const addSavedItemToCart = async (item) => {
      const key = savedItemKey(item);
      if (!item || savedListAddingIds.has(key)) return;
      startSession("saved_item_add_to_cart");
      savedListAddingIds.add(key);
      renderShortlist();
      const added = await addSavedItemsToCart([item], { source: "item", clearOnSuccess: false, openCart: true });
      savedListAddingIds.delete(key);
      if (added) {
        savedListAddedIds.add(key);
        setSavedListToast(`${displayTitleFor(item) || item.title || "Snack"} added to cart`);
      }
      renderShortlist();
    };

    const addAllToCart = async () => {
      const saved = getSaved();
      const totals = savedListTotals(saved);
      startSession("saved_add_all_to_cart");
      if (!saved.length) {
        setStatus("Snack List is empty");
        return;
      }
      if (!totals.selected.length) {
        setStatus("Select at least one saved snack to add");
        return;
      }
      const added = await addSavedItemsToCart(totals.selected, {
        source: "bulk",
        clearOnSuccess: true,
        openCart: true
      });
      if (added) {
        setSavedListToast(`${totals.quantity} snack${totals.quantity === 1 ? "" : "s"} added to cart`);
      }
    };

    const animateCartBeam = () => {
      if (!els.card) return;
      els.card.classList.remove("is-carting");
      window.requestAnimationFrame(() => {
        els.card.classList.add("is-carting");
        window.setTimeout(() => els.card?.classList.remove("is-carting"), 620);
      });
    };

    const addCurrentToCart = async () => {
      const product = detailsProductOverride && detailsOpen ? detailsProductOverride : currentProduct();
      if (!product) return;
      if (!productIsPurchasable(product)) {
        setStatus("Show available snacks to keep swiping");
        return;
      }
      const cartSource = detailsOpen ? "detail" : "card";
      const trackingParams = productTrackingParams(product);
      const value = Number(product.priceCents || 0) / 100;
      startSession("add_to_cart");
      addToCartClickCount += 1;
      trackSnackSwipe("snack_swipe_add_to_cart_click", {
        ...trackingParams,
        source: cartSource,
        cart_source: cartSource,
        prior_swipe_action: savedListContainsProduct(product) ? "saved" : "none",
        quantity: 1,
        item_count: 1,
        value
      });
      if (launchProductMatches(product)) {
        launchProductPending = false;
        launchIntelPending = false;
      }
      animateCartBeam();
      if (root.dataset.localPreview === "true" || root.dataset.demoProducts === "true" || window.location.protocol === "file:") {
        await handleCurrentCartSuccess(product, cartSource, trackingParams, { openCart: false });
        setStatus(`Local test: ${product.title} added to test cart`);
        return;
      }
      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: Number(product.variantId), quantity: 1 })
        });
        if (!response.ok) throw new Error("Cart add failed");
        await handleCurrentCartSuccess(product, cartSource, trackingParams);
      } catch (error) {
        console.warn(error);
        setStatus("Could not add product to cart");
        trackSnackSwipe("snack_swipe_add_to_cart_result", {
          ...trackingParams,
          result: "failure",
          source: cartSource,
          cart_source: cartSource,
          prior_swipe_action: savedListContainsProduct(product) ? "saved" : "none",
          quantity: 1,
          item_count: 1,
          value,
          error_code: "cart_add_failed",
          error_message_safe: safeErrorMessage(error)
        });
        trackSnackSwipe("snack_swipe_error", {
          ...trackingParams,
          error_area: "cart_add",
          error_code: "cart_add_failed",
          error_message_safe: safeErrorMessage(error)
        });
      }
    };

    const selectedButtonText = (attribute, value) => {
      if (!value) return "";
      const button = root.querySelector(`[${attribute}="${value}"]`);
      return button ? button.textContent.trim().replace(/\s+/g, " ") : value;
    };

    const selectedButtonTexts = (attribute, values) => {
      const selected = Array.isArray(values) ? values : [];
      return selected.map((value) => selectedButtonText(attribute, value)).filter(Boolean).join(" OR ");
    };

    const selectedFilters = () => [
      ...activeFilters.map((value) => ["filter", selectedButtonText("data-gs-filter", value), value]),
      ...activeCountries.map((value) => ["country", selectedButtonText("data-gs-country", value), value]),
      ...activeSnackTypes.map((value) => ["snackType", selectedButtonText("data-gs-snack-type", value), value]),
      ...activeMissions.map((value) => ["mission", selectedButtonText("data-gs-mission", value), value])
    ].filter((item) => item[1]);

    const updateApplyFilterCount = () => {
      if (!els.applyFiltersButton) return;
      const count = swipeDeckProducts.filter((product) => productMatchesRoute(product, {
        filters: draftFilters,
        countries: draftCountries,
        snackTypes: draftSnackTypes,
        missions: draftMissions
      })).length;
      const criteriaCount = draftFilters.length + draftCountries.length + draftSnackTypes.length + draftMissions.length;
      const snackWord = count === 1 ? "Snack" : "Snacks";
      els.applyFiltersButton.innerHTML = `${count ? `Show ${count} ${snackWord}` : "No Snacks Found"} ${filterIconSvg("arrow_right", "gs-swipe-filter__apply-svg")}`;
      els.applyFiltersButton.dataset.gsResultCount = String(count);
      if (els.filterResultCount) els.filterResultCount.textContent = String(count);
      if (els.filterCriteriaCount) els.filterCriteriaCount.textContent = String(criteriaCount);
    };

    const setButtonActive = (button, active) => {
      button.classList.toggle("is-active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    };

    const settleFilterButtonFocus = (button, event, options = {}) => {
      const coarsePointer = window.matchMedia?.("(pointer: coarse)")?.matches;
      const pointerActivated = !event || event.detail > 0 || coarsePointer || options.force || ["click", "pointerup", "pointerdown", "touchend", "mouseup"].includes(event.type);
      if (!button || !pointerActivated || typeof button.blur !== "function") return;
      const blurActiveControl = () => {
        button.blur();
        const active = document.activeElement;
        if (active && active !== document.body && root.contains(active) && typeof active.blur === "function") {
          active.blur();
        }
      };
      window.requestAnimationFrame(blurActiveControl);
      window.setTimeout(blurActiveControl, 80);
    };

    let refreshAvailableFilterOptions = () => {};

    const updateFilterButtonStates = () => {
      refreshAvailableFilterOptions();
      root.querySelectorAll("[data-gs-filter]").forEach((button) => {
        setButtonActive(button, draftFilters.includes(button.dataset.gsFilter));
      });
      root.querySelectorAll("[data-gs-country]").forEach((button) => {
        setButtonActive(button, draftCountries.includes(button.dataset.gsCountry));
      });
      root.querySelectorAll("[data-gs-mission]").forEach((button) => {
        setButtonActive(button, draftMissions.includes(button.dataset.gsMission));
      });
      root.querySelectorAll("[data-gs-snack-type]").forEach((button) => {
        setButtonActive(button, draftSnackTypes.includes(button.dataset.gsSnackType));
      });
      updateApplyFilterCount();
    };

    const syncDraftFilters = () => {
      draftFilters = activeFilters.slice();
      draftCountries = activeCountries.slice();
      draftSnackTypes = activeSnackTypes.slice();
      draftMissions = activeMissions.slice();
      updateFilterButtonStates();
    };

    const updateRoute = () => {
      if (!els.route || !els.activeChips) return;
      const route = selectedFilters();
      els.route.hidden = !route.length;
      els.activeChips.innerHTML = "";
      const maxVisible = window.matchMedia?.("(max-width: 540px)")?.matches ? 3 : 5;
      route.slice(0, maxVisible).forEach(([type, label, value]) => {
        const chip = document.createElement("button");
        chip.type = "button";
        chip.dataset.gsRemoveFilter = type;
        chip.dataset.gsRemoveValue = value;
        chip.innerHTML = `<span>${label}</span><small aria-hidden="true">×</small>`;
        chip.setAttribute("aria-label", `Remove ${label} filter`);
        chip.addEventListener("click", () => removeActiveFilter(type, value));
        els.activeChips.appendChild(chip);
      });
      if (route.length > maxVisible) {
        const more = document.createElement("button");
        more.type = "button";
        more.className = "is-more";
        more.textContent = `+${route.length - maxVisible}`;
        more.setAttribute("aria-label", "Open filters to see more active filters");
        more.addEventListener("click", openFilterOverlay);
        els.activeChips.appendChild(more);
      }
      if (route.length) {
        const clear = document.createElement("button");
        clear.type = "button";
        clear.className = "is-clear";
        clear.textContent = "Clear";
        clear.setAttribute("aria-label", "Clear all active filters");
        clear.addEventListener("click", () => removeActiveFilter("all"));
        els.activeChips.appendChild(clear);
      }
    };

    const missionMatches = (product, mission) => {
      if (!mission) return true;
      const text = productText(product);
      const key = normalizeSlug(mission);
      const explicitMissions = listValues(product.missions).map(normalizeSlug);
      const compareAt = Number(product.compareAtPriceCents || 0);
      const price = Number(product.priceCents || 0);
      const missionAliases = {
        staff_picks: ["staff_picks", "staff_pick", "staff"],
        best_sellers: ["best_sellers", "best_seller", "best"],
        last_chance: ["last_chance", "lastchance"],
        under_5: ["under_5", "under5", "under_five"],
        sale: ["sale", "on_sale"],
        international: ["international", "imported"]
      };
      if ((missionAliases[key] || [key]).some((alias) => explicitMissions.includes(alias))) return true;
      if (explicitMissions.includes(key)) return true;
      if (key === "under_5") return isUnderFive(product) || text.includes("under_5") || text.includes("under $5") || text.includes("$5 snack");
      if (key === "sale") return product.onSale === true || (compareAt && price && compareAt > price) || text.includes("merch:sale") || text.includes("on sale") || text.includes("discount");
      if (key === "international") {
        const origin = normalizeSlug(countryFor(product));
        const domesticOrigins = new Set(["us", "usa", "u_s", "united_states", "unitedstates", "united_states_of_america", "america"]);
        return Boolean(origin && !domesticOrigins.has(origin)) || text.includes("international") || text.includes("imported");
      }
      return false;
    };

    const snackTypeMatches = (product, snackType) => {
      const key = normalizeSlug(snackType);
      const aliases = {
        candy: ["candy", "confectionery"],
        chips: ["chips", "chip", "crisps", "pretzels", "pretzel"],
        chocolate: ["chocolate", "chocolates", "bar"],
        cookies: ["cookies", "cookie", "biscuits", "biscuit"],
        drinks: ["drinks", "drink", "soda", "beverage", "juice"],
        freeze_dried: ["freeze_dried", "freeze", "freeze_dry", "freeze_dried_snack"],
        gummies: ["gummies", "gummy", "gummi"],
        merch: ["merch", "swag", "shirt", "tee", "hat", "apparel"],
        other: ["other"]
      };
      const aliasList = aliases[key] || [key];
      const matchesAlias = (value) => aliasList.some((alias) => normalizeSlug(value) === normalizeSlug(alias));
      const explicitTypes = uniqueCanonicalValues([
        ...splitCombinedMetaValues(product.snackTypes),
        ...splitCombinedMetaValues(product.snackType),
        ...splitCombinedMetaValues(product.snack_type),
        ...splitCombinedMetaValues(product?.metafields?.snack_swipe?.snack_type),
        ...splitCombinedMetaValues(product?.metafields?.snack_swipe?.snack_type?.value),
        ...splitCombinedMetaValues(product?.metafields?.snack_swipe?.snack_types),
        ...splitCombinedMetaValues(product?.metafields?.snack_swipe?.snack_types?.value),
        ...splitCombinedMetaValues(product?.metafields?.["snack_swipe.snack_type"]),
        ...splitCombinedMetaValues(product?.metafields?.["snack_swipe.snack_types"])
      ], canonicalSnackTypeFor);
      if (explicitTypes.length) {
        return explicitTypes.some(matchesAlias);
      }
      const fallbackTypes = snackTypeValuesFor(product);
      if (fallbackTypes.length) return fallbackTypes.some(matchesAlias);
      const snackTypeText = normalizeSlug(`${productText(product)} ${classFor(product)}`);
      return aliasList.some((alias) => snackTypeText.includes(normalizeSlug(alias)));
    };

    const productMatchesRoute = (product, route = {}) => {
      const filters = route.filters || activeFilters;
      const countries = route.countries || activeCountries;
      const snackTypes = route.snackTypes || activeSnackTypes;
      const missions = route.missions || activeMissions;
      const matchesFlavorProfile = filters.length
        ? filters.some((filter) => flavorProfileTags(product).some((tag) => lower(tag) === filter || lower(tag).includes(filter)))
        : true;
      const productCountry = lower(countryFor(product));
      const matchesCountry = countries.length
        ? countries.some((country) => productCountry === country || productCountry.includes(country))
        : true;
      const matchesSnackType = snackTypes.length ? snackTypes.some((snackType) => snackTypeMatches(product, snackType)) : true;
      const matchesMission = !missions.length || missions.some((mission) => missionMatches(product, mission));
      return matchesFlavorProfile && matchesCountry && matchesSnackType && matchesMission;
    };

    const availableFilterValues = () => {
      const values = {
        filters: new Set(),
        countries: new Set(),
        snackTypes: new Set(),
        missions: new Set()
      };
      const hasMatchingProduct = (route) => swipeDeckProducts.some((product) => productMatchesRoute(product, route));

      root.querySelectorAll("[data-gs-filter]").forEach((button) => {
        const value = button.dataset.gsFilter;
        if (value && hasMatchingProduct({ filters: [value], countries: [], snackTypes: [], missions: [] })) values.filters.add(value);
      });
      root.querySelectorAll("[data-gs-country]").forEach((button) => {
        const value = button.dataset.gsCountry;
        if (value && hasMatchingProduct({ filters: [], countries: [value], snackTypes: [], missions: [] })) values.countries.add(value);
      });
      root.querySelectorAll("[data-gs-snack-type]").forEach((button) => {
        const value = button.dataset.gsSnackType;
        if (value && hasMatchingProduct({ filters: [], countries: [], snackTypes: [value], missions: [] })) values.snackTypes.add(value);
      });
      root.querySelectorAll("[data-gs-mission]").forEach((button) => {
        const value = button.dataset.gsMission;
        if (value && hasMatchingProduct({ filters: [], countries: [], snackTypes: [], missions: [value] })) values.missions.add(value);
      });

      return values;
    };

    const pruneUnavailableFilterValues = (values = availableFilterValues()) => {
      const keep = (items, available) => items.filter((item) => available.has(item));
      activeFilters = keep(activeFilters, values.filters);
      activeCountries = keep(activeCountries, values.countries);
      activeSnackTypes = keep(activeSnackTypes, values.snackTypes);
      activeMissions = keep(activeMissions, values.missions);
      draftFilters = keep(draftFilters, values.filters);
      draftCountries = keep(draftCountries, values.countries);
      draftSnackTypes = keep(draftSnackTypes, values.snackTypes);
      draftMissions = keep(draftMissions, values.missions);
    };

    refreshAvailableFilterOptions = () => {
      const values = availableFilterValues();
      const toggleOption = (button, available) => {
        button.hidden = !available;
        button.disabled = !available;
        button.setAttribute("aria-hidden", available ? "false" : "true");
        if (!available) setButtonActive(button, false);
      };

      root.querySelectorAll("[data-gs-filter]").forEach((button) => toggleOption(button, values.filters.has(button.dataset.gsFilter)));
      root.querySelectorAll("[data-gs-country]").forEach((button) => toggleOption(button, values.countries.has(button.dataset.gsCountry)));
      root.querySelectorAll("[data-gs-snack-type]").forEach((button) => toggleOption(button, values.snackTypes.has(button.dataset.gsSnackType)));
      root.querySelectorAll("[data-gs-mission]").forEach((button) => toggleOption(button, values.missions.has(button.dataset.gsMission)));

      root.querySelectorAll("[data-gs-filter-section]").forEach((section) => {
        const hasVisibleOptions = Array.from(section.querySelectorAll(".gs-swipe-filter__row button")).some((button) => !button.hidden);
        section.hidden = !hasVisibleOptions;
      });

      pruneUnavailableFilterValues(values);
    };

    const rebuildProductsForRoute = () => {
      const launchProduct = launchProductPending ? findLaunchProduct() : null;
      const nextProducts = swipeDeckProducts
        .filter((product) => productMatchesRoute(product))
        .filter((product) => !isProductExcludedForSession(product));

      if (launchProduct) {
        return [
          launchProduct,
          ...nextProducts.filter((product) => productSessionKey(product) !== productSessionKey(launchProduct))
        ];
      }

      return nextProducts;
    };

    const applyFilters = () => {
      pruneUnavailableFilterValues();
      products = rebuildProductsForRoute();
      index = 0;
      lastSwipe = null;
      deckCompletedTracked = false;
      lastViewedEventKey = "";
      skippedCount = 0;
      savedDecisionCount = 0;
      addedToCartCount = 0;
      syncDraftFilters();
      updateRoute();
      render();
    };

    const showAvailableDeck = () => {
      launchProductPending = false;
      launchIntelPending = false;
      detailsProductOverride = null;
      detailsOpen = false;
      products = rebuildProductsForRoute();
      index = 0;
      lastSwipe = null;
      lastViewedEventKey = "";
      setStatus("Showing available snacks");
      render();
    };

    const commitFilterDraft = () => {
      startSession("filters_applied");
      activeFilters = draftFilters.slice();
      activeCountries = draftCountries.slice();
      activeSnackTypes = draftSnackTypes.slice();
      activeMissions = draftMissions.slice();
      applyFilters();
      filtersAppliedCount += 1;
      trackSnackSwipe("snack_swipe_filter_apply", {
        ...baseTrackingParams(),
        ...selectedRouteParams(),
        result_count: products.length
      });
      if (!products.length) {
        trackSnackSwipe("snack_swipe_no_results", {
          ...baseTrackingParams(),
          ...selectedRouteParams(),
          result_count: 0
        });
      }
      closeFilterOverlay();
    };

    const clearFilterDraft = () => {
      draftFilters = [];
      draftCountries = [];
      draftSnackTypes = [];
      draftMissions = [];
      updateFilterButtonStates();
    };

    const clearAllFilters = () => {
      activeFilters = [];
      activeCountries = [];
      activeSnackTypes = [];
      activeMissions = [];
      clearFilterDraft();
      applyFilters();
    };

    const removeFromArray = (items, value) => {
      return value ? items.filter((item) => item !== value) : [];
    };

    const removeActiveFilter = (type, value) => {
      if (type === "filter" || type === "all") activeFilters = type === "all" ? [] : removeFromArray(activeFilters, value);
      if (type === "country" || type === "all") activeCountries = type === "all" ? [] : removeFromArray(activeCountries, value);
      if (type === "snackType" || type === "all") activeSnackTypes = type === "all" ? [] : removeFromArray(activeSnackTypes, value);
      if (type === "mission" || type === "all") activeMissions = type === "all" ? [] : removeFromArray(activeMissions, value);
      applyFilters();
    };

    const toggleDraftValue = (items, value) => {
      if (!value) return items;
      return items.includes(value) ? items.filter((item) => item !== value) : [...items, value];
    };

    const trackFilterValueToggle = (group, value, selected) => {
      trackSnackSwipe("snack_swipe_filter_value_toggled", {
        ...baseTrackingParams(),
        ...selectedRouteParams({
          filters: draftFilters,
          countries: draftCountries,
          snackTypes: draftSnackTypes,
          missions: draftMissions
        }),
        filter_group: group,
        filter_value: normalizeSlug(value),
        action: selected ? "selected" : "deselected",
        draft_selected_value_count: draftFilters.length + draftCountries.length + draftSnackTypes.length + draftMissions.length
      });
    };

    const applyFilter = (filter) => {
      draftFilters = toggleDraftValue(draftFilters, filter);
      updateFilterButtonStates();
      trackFilterValueToggle("flavor", filter, draftFilters.includes(filter));
    };

    const applyCountry = (country) => {
      draftCountries = toggleDraftValue(draftCountries, country);
      updateFilterButtonStates();
      trackFilterValueToggle("country", country, draftCountries.includes(country));
    };

    const applySnackType = (snackType) => {
      draftSnackTypes = toggleDraftValue(draftSnackTypes, snackType);
      updateFilterButtonStates();
      trackFilterValueToggle("type", snackType, draftSnackTypes.includes(snackType));
    };

    const applyMission = (mission) => {
      draftMissions = toggleDraftValue(draftMissions, mission);
      updateFilterButtonStates();
      trackFilterValueToggle("mission", mission, draftMissions.includes(mission));
    };

    const attachEvents = () => {
      const energizeButton = (button) => {
        if (!button) return;
        button.classList.remove("is-energized");
        window.requestAnimationFrame(() => {
          button.classList.add("is-energized");
          window.setTimeout(() => button.classList.remove("is-energized"), 340);
        });
      };

      listen(root, "pointerdown", () => {
        root.classList.add("is-pointer-mode");
      }, { passive: true });

      listen(root, "pointerup", (event) => {
        const control = event.target?.closest?.("button, a");
        if (!control || !root.contains(control)) return;
        settleFilterButtonFocus(control, event, { force: true });
        window.setTimeout(() => root.classList.remove("is-pointer-mode"), 180);
      }, { passive: true });

      const activateDecision = (type, event) => {
        event?.preventDefault();
        event?.stopPropagation();
        if (isAnimating) return;
        const now = Date.now();
        if (now - lastDecisionAt < 760) return;
        lastDecisionAt = now;
        energizeButton(event?.currentTarget);
        decide(type, "button");
      };

      const activateFilterApply = (event) => {
        event?.preventDefault();
        event?.stopPropagation();
        event?.stopImmediatePropagation?.();
        const now = Date.now();
        if (now - lastFilterApplyAt < 420) return;
        lastFilterApplyAt = now;
        filterApplyShieldUntil = now + 760;
        root.classList.add("is-filter-committing");
        window.setTimeout(() => {
          if (Date.now() >= filterApplyShieldUntil) root.classList.remove("is-filter-committing");
        }, 780);
        energizeButton(els.applyFiltersButton);
        commitFilterDraft();
      };

      const bindDecisionButton = (selector, type) => {
        root.querySelectorAll(selector).forEach((button) => {
          button.addEventListener("pointerup", (event) => {
            activateDecision(type, event);
            settleFilterButtonFocus(event.currentTarget, event);
          });
          button.addEventListener("click", (event) => {
            activateDecision(type, event);
            settleFilterButtonFocus(event.currentTarget, event);
          });
        });
      };

      bindDecisionButton("[data-gs-skip]", "skip");
      bindDecisionButton("[data-gs-like]", "like");
      const detailsToggle = root.querySelector("[data-gs-details-toggle]");
      detailsToggle?.addEventListener("click", (event) => {
        if (suppressNextProductClick) {
          event.preventDefault();
          suppressNextProductClick = false;
          return;
        }
        detailsProductOverride = null;
        toggleDetails(undefined, { returnFocus: detailsToggle });
      });
      detailsToggle?.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        detailsProductOverride = null;
        toggleDetails(undefined, { returnFocus: detailsToggle });
      });
      els.detailsClose?.addEventListener("click", () => toggleDetails(false));
      els.details?.addEventListener("click", (event) => {
        if (event.target === els.details) toggleDetails(false);
      });
      els.filterToggle?.addEventListener("click", (event) => {
        openFilterOverlay();
        settleFilterButtonFocus(event.currentTarget, event);
      });
      els.routeEdit?.addEventListener("click", openFilterOverlay);
      root.querySelectorAll("[data-gs-close-filters]").forEach((button) => button.addEventListener("click", closeFilterOverlay));
      els.applyFiltersButton?.addEventListener("pointerup", activateFilterApply);
      els.applyFiltersButton?.addEventListener("click", activateFilterApply);
      root.querySelector("[data-gs-clear-filters]")?.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        clearAllFilters();
        settleFilterButtonFocus(event.currentTarget, event, { force: true });
      });
      root.querySelectorAll("[data-gs-filter-section-toggle]").forEach((button) => {
        button.addEventListener("click", () => {
          const section = button.closest("[data-gs-filter-section]");
          if (!section) return;
          const isExpanded = !section.classList.contains("is-expanded");
          section.classList.toggle("is-expanded", isExpanded);
          button.setAttribute("aria-expanded", isExpanded ? "true" : "false");
        });
      });
      els.undo?.addEventListener("click", undoLastSwipe);
      root.querySelector("[data-gs-start]")?.addEventListener("click", advanceTour);
      root.querySelector("[data-gs-tour-skip]")?.addEventListener("click", () => closeIntro("skipped"));
      root.querySelectorAll("[data-gs-open-intro]").forEach((button) => button.addEventListener("click", (event) => {
        startSession("manual_guide");
        closeGestureDemo("guide_opened");
        closeFilterTip("guide_opened", false);
        if (els.gestureDemo) {
          replayGestureDemo();
        } else {
          openIntro("manual_guide_button");
        }
        settleFilterButtonFocus(event.currentTarget, event);
      }));
      els.gestureDemoDismiss?.addEventListener("click", () => closeGestureDemo("manual"));
      els.filterTipClose?.forEach((button) => {
        button.addEventListener("click", () => closeFilterTip("manual"));
      });
      els.filterTipOpen?.addEventListener("click", () => {
        closeFilterTip("open_filters");
        openFilterOverlay();
      });
      root.querySelectorAll("[data-gs-open-list]").forEach((button) => button.addEventListener("click", (event) => {
        openList();
        settleFilterButtonFocus(event.currentTarget, event);
      }));
      root.querySelectorAll("[data-gs-close-list]").forEach((button) => button.addEventListener("click", closeList));
      root.querySelector("[data-gs-add-all]")?.addEventListener("click", addAllToCart);
      els.unavailableShow?.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        showAvailableDeck();
      });
      root.querySelector("[data-gs-add-current]")?.addEventListener("click", (event) => {
        if (Date.now() < filterApplyShieldUntil) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        energizeButton(event.currentTarget);
        addCurrentToCart();
        settleFilterButtonFocus(event.currentTarget, event);
      });
      els.detailsAdd?.addEventListener("click", (event) => {
        energizeButton(event.currentTarget);
        addCurrentToCart();
        settleFilterButtonFocus(event.currentTarget, event);
      });
      els.detailsLink?.addEventListener("click", () => {
        startSession("view_product");
        trackSnackSwipe("snack_swipe_view_product_click", productTrackingParams(detailProduct()));
      });
      root.querySelectorAll("[data-gs-filter]").forEach((button) => {
        button.addEventListener("click", (event) => {
          applyFilter(button.dataset.gsFilter);
          settleFilterButtonFocus(button, event);
        });
      });
      root.querySelectorAll("[data-gs-country]").forEach((button) => {
        button.addEventListener("click", (event) => {
          applyCountry(button.dataset.gsCountry);
          settleFilterButtonFocus(button, event);
        });
      });
      root.querySelectorAll("[data-gs-mission]").forEach((button) => {
        button.addEventListener("click", (event) => {
          applyMission(button.dataset.gsMission);
          settleFilterButtonFocus(button, event);
        });
      });
      root.querySelectorAll("[data-gs-snack-type]").forEach((button) => {
        button.addEventListener("click", (event) => {
          applySnackType(button.dataset.gsSnackType);
          settleFilterButtonFocus(button, event);
        });
      });

      const handleKeydown = (event) => {
        if (event.defaultPrevented) return;
        const target = event.target;
        const isTyping = target && ["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName);
        if (externalCartIsActive() || isInExternalCart(target)) return;
        if (isTyping || event.metaKey || event.ctrlKey || event.altKey) return;
        const activeLayer = activeModalLayer();
        if (activeLayer) {
          if (event.key === "Tab") {
            trapFocusWithin(activeLayer.node, event);
            return;
          }
          if (event.key === "Escape") {
            event.preventDefault();
            event.stopPropagation();
            activeLayer.close();
          }
          return;
        }
        if (event.key === "Escape") {
          event.preventDefault();
          event.stopPropagation();
          postPortalMessage("gs-snack-swipe:exit");
          return;
        }
        if (event.key === "ArrowLeft") {
          event.preventDefault();
          event.stopPropagation();
          decide("skip", "keyboard");
          return;
        }
        if (event.key === "ArrowRight") {
          event.preventDefault();
          event.stopPropagation();
          decide("like", "keyboard");
          return;
        }
        if (event.key.toLowerCase() === "i") {
          event.preventDefault();
          event.stopPropagation();
          toggleDetails(undefined, { returnFocus: els.card });
        }
      };

      listen(root, "keydown", handleKeydown);
      const handleDocumentKeydown = (event) => {
        if (!root.contains(event.target)) return;
        handleKeydown(event);
      };
      listen(document, "keydown", handleDocumentKeydown);
      const handleDocumentPointerdown = (event) => {
        if (!els.filterTip || els.filterTip.hidden) return;
        if (event.target.closest("[data-gs-filter-tip], [data-gs-toggle-filters]")) return;
        closeFilterTip("outside");
      };
      listen(document, "pointerdown", handleDocumentPointerdown);
      const handlePortalCloseRequest = () => {
        trackSessionSummary("overlay_close");
        closeFilterOverlay({ restoreFocus: false });
        closeList({ restoreFocus: false });
        toggleDetails(false, { restoreFocus: false });
        closeGestureDemo("overlay_close");
      };
      const handlePortalMessage = (event) => {
        const type = event.data?.type;
        if (!isPortalMode || event.source !== window.parent || event.origin !== window.location.origin || typeof type !== "string" || !type.startsWith("gs-snack-swipe:")) return;
        if (type === "gs-snack-swipe:show-gesture-intro") {
          replayGestureDemo();
        }
        if (type === "gs-snack-swipe:close-requested") {
          handlePortalCloseRequest();
        }
      };
      const handlePagehide = () => trackSessionSummary("pagehide");
      listen(window, "message", handlePortalMessage);
      listen(window, "gs-snack-swipe:close-requested", handlePortalCloseRequest);
      listen(window, "pagehide", handlePagehide);
      listen(window, "resize", positionTourSpotlight);
      listen(window, "scroll", positionTourSpotlight, { passive: true });

      let startX = 0;
      let startY = 0;
      let currentX = 0;
      let currentY = 0;
      let isDragging = false;
      let hasDragged = false;
      let suppressNextProductClick = false;

      els.productLinks.forEach((link) => {
        listen(link, "click", (event) => {
          event.preventDefault();
          if (!suppressNextProductClick && !isAnimating) toggleDetails(true, { returnFocus: link });
          suppressNextProductClick = false;
        });
      });

      const onPointerMove = (event) => {
        if (!isDragging || !els.card) return;
        currentX = event.clientX - startX;
        currentY = event.clientY - startY;
        const absX = Math.abs(currentX);
        const distance = Math.hypot(currentX, currentY);

        if (distance > 6) {
          event.preventDefault();
          if (!hasDragged) {
            els.card.classList.add("is-lifted");
            hasDragged = true;
          }
          suppressNextProductClick = true;
        }
        if (!hasDragged) return;
        const visualY = Math.max(-90, Math.min(90, currentY));
        const rotate = Math.max(-10, Math.min(10, currentX / 18));
        els.card.style.transform = `translate(${currentX}px, ${visualY - 7}px) scale(1.01) rotate(${rotate}deg)`;
        els.card.classList.toggle("is-like", currentX > 60);
        els.card.classList.toggle("is-skip", currentX < -60);
        if (els.reaction) els.reaction.textContent = currentX > 0 ? "Save!" : "Skip";
      };

      const onPointerUp = (event) => {
        if (!isDragging || !els.card) return;
        isDragging = false;
        els.card.releasePointerCapture?.(event.pointerId);
        const distance = Math.hypot(currentX, currentY);
        if (!hasDragged) {
          resetCardMotion();
          event.preventDefault();
          suppressNextProductClick = true;
          if (!isAnimating) toggleDetails(true, { returnFocus: els.card });
          currentX = 0;
          currentY = 0;
          hasDragged = false;
          window.setTimeout(() => {
            suppressNextProductClick = false;
          }, 160);
          return;
        }
        const hasSwipeIntent = Math.abs(currentX) > 70 && Math.abs(currentX) / Math.max(distance, 1) > 0.24;
        if (hasSwipeIntent) {
          event.preventDefault();
          suppressNextProductClick = true;
          decide(currentX > 0 ? "like" : "skip", event.pointerType === "touch" ? "swipe" : "drag");
        } else {
          resetCardMotion();
        }
        currentX = 0;
        currentY = 0;
        hasDragged = false;
        window.setTimeout(() => {
          suppressNextProductClick = false;
        }, 160);
      };

      if (els.card) {
        listen(els.card, "dragstart", (event) => {
          event.preventDefault();
        });
        listen(els.card, "pointerdown", (event) => {
          if (!currentProduct() || isAnimating) return;
          if (event.pointerType === "mouse" && event.button !== 0) return;
          if (event.target.closest("button, .gs-swipe-card__details a")) return;
          event.preventDefault();
          startX = event.clientX;
          startY = event.clientY;
          currentX = 0;
          currentY = 0;
          isDragging = true;
          hasDragged = false;
          els.card.pointerId = event.pointerId;
          els.card.setPointerCapture?.(event.pointerId);
        });
        listen(els.card, "pointermove", onPointerMove);
        listen(els.card, "pointerup", onPointerUp);
        listen(els.card, "pointercancel", onPointerUp);
      }
    };

    trackSnackSwipe("snack_swipe_open", {
      ...baseTrackingParams(),
      open_source: isPortalMode ? "overlay" : "standalone",
      launch_product: launchProductHandle || "",
      launch_view: launchView || "card",
      launch_intro_mode: launchIntroMode || "default"
    });
    attachEvents();
    renderShortlist();
    updateCartCount();
    const launchProductFound = Boolean(launchProductHandle && findLaunchProduct());
    debugLog("init", {
      portal: isPortalMode,
      launch_product: launchProductHandle || null,
      launch_product_found: launchProductFound,
      launch_view: launchView || "card",
      launch_intro: launchIntroMode || "default",
      route: {
        filters: activeFilters,
        countries: activeCountries,
        snack_types: activeSnackTypes,
        missions: activeMissions
      },
      all_product_count: allProducts.length,
      swipe_eligible_product_count: swipeDeckProducts.length,
      swiped_session_count: swipedProductKeys.size,
      cart_excluded_session_count: addedToCartProductKeys.size
    });
    if (!launchProductFound) {
      launchProductPending = false;
      launchIntelPending = false;
    }
    applyFilters();
    debugLog("deck ready", {
      deck_size: products.length,
      current_product: currentProduct()?.handle || null,
      launch_product_pending: launchProductPending
    });
    const shouldOpenLaunchIntel = launchIntelPending && launchIntroMode !== "force";
    if (shouldOpenLaunchIntel && currentProduct() && launchProductMatches(currentProduct())) {
      window.setTimeout(() => {
        if (!currentProduct() || !launchProductMatches(currentProduct())) return;
        toggleDetails(true, { returnFocus: els.card });
        launchIntelPending = false;
      }, 180);
    }
    maybeShowGestureDemo({
      force: launchIntroMode === "force",
      suppress: launchIntroMode === "suppress" || (launchIntelPending && launchIntroMode !== "force")
    });
    postPortalMessage("gs-snack-swipe:ready", {
      deck_size: products.length,
      launch_product_found: launchProductFound,
      launch_view: launchView || "card"
    });
  };

  const init = () => {
    document.querySelectorAll(".gs-swipe").forEach((root) => {
      if (!root.dataset.initialized) {
        root.dataset.initialized = "true";
        initSwipe(root);
      }
    });
  };

  const destroyAll = () => {
    document.querySelectorAll(".gs-swipe[data-initialized]").forEach((root) => {
      if (typeof root.__gsSwipeDestroy === "function") {
        root.__gsSwipeDestroy();
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.GalacticSnackSwipeApp = {
    init,
    destroyAll
  };
})();
